import React, { useState, useEffect, useRef, Children } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Input,
  Button,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  Table,
} from "reactstrap";
import PriceUtils from '../../helpers/PriceUtils';
import Select, { components } from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import { cloneDeep, isEmpty, indexOf } from "lodash";
import APIClient from "../../helpers/APIClient";
import PageTitle from "../../components/PageTitle";
import PageBody from "../../components/PageBody";
import Loader from "../../components/Loader";
import ModalPopup from "../../components/ModalPopup";
import { connect } from "react-redux";
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { baseUrl } from "../../constants/environment";
import styled from "styled-components";
import PhoneImageIcon from "../../assets/images/icon-phone.png";
import CustomerTab from "./components/CustomerTab";
import ReceiptsAdd from "../receipts/ReceiptsAdd";
import PaymentAdd from "../payment/PaymentAdd";
import ActionAdd from "./components/ActionAdd";
import CustomerHistory from "./components/CustomerHistory";
import CalcUtils from "../../helpers/CalcUltils";
import img_bg_upload from "../../assets/images/file-drop-upload.png";
import IconEdit from "../../assets/images/icon-edit.png";
import RowEmpty from "../../components/RowEmpty";
import AddressAdd from "./components/AddressAdd";
import CustomerChart from "./components/CustomerChart";
import NavTabNutri from "../../components/NavTabNutri";
import queryString from "query-string";
import RowLoading from "../../components/RowLoading";
import IconSearch from '../../assets/images/icon-search.png';
import IconDolla from "../../assets/images/icon_dolla.png";
import { MultiSelect } from "react-multi-select-component";
import AsyncSelect from "react-select/async";
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import InputTitleTop from '../../components/InputTitleTop'
import Pagination from '../../components/Pagination';
import IconSetting from '../../assets/images/icon-setting.png';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { COLUMN_ORDER } from '../../constants/layout';
import { arrayMoveImmutable } from 'array-move';
import IconCheckedActive from '../../assets/images/icon-checked-active.png';
import IconChecked from '../../assets/images/icon-checked-empty.png';
import IconCheckedDisiable from '../../assets/images/icon-checked.png';
import IconSort from '../../assets/images/icon-sort.png';
import { changeColumnOrder } from '../../redux/layout/actions';

const configPage = {
  titlePage: "Thêm hồ sơ khách hàng",
  pathPage: "/custommer",
  column: 10,
};

const TABS: any = [
  {
    value: 'info',
    label: "Thông tin chung",
  },
  {
    value: 'chart',
    label: "Biểu đồ theo dõi",
  },
  {
    value: 'monitor',
    label: "Theo dõi đồng hành",
  },
  {
    value: 'service',
    label: "Gói thẻ dịch vụ",
  },

];

interface Props {
  history: any;
  location: any;
  match: any;
  user: any;
}
const StatusList: any = [
  {
    value: "activeExamination",
    label: "Đang hoạt động",
  },
  {
    value: "new",
    label: "Chưa hoạt động",
  },
  {
    value: "finished",
    label: "Đã kết thúc",
  },
]
export const PaymentStatusList: any = [
  {
    value: "paid",
    label: "Đã thanh toán",
  },
  {
    value: "partiallypaid",
    label: "Thanh toán 1 phần",
  },
  {
    value: "unpaid",
    label: "Chưa thanh toán",
  },
];

const SourceList: any = [
  {
    value: 1,
    label: "Nguồn tự tìm kiếm",
  },
  {
    value: 2,
    label: "Nguồn tự phát triển",
  },
  {
    value: 3,
    label: "Nguồn Marketing",
  },
  {
    value: 4,
    label: "Nguồn Facebook ads",
  },
  {
    value: 5,
    label: "Nguồn Zalo",
  },
  {
    value: 6,
    label: "Nguồn Tiktok",
  },
  {
    value: 7,
    label: "Nguồn Website",
  },
  {
    value: 8,
    label: "Nguồn landing page",
  },
  {
    value: 9,
    label: "Nguồn Google",
  },
  {
    value: 10,
    label: "Nguồn Youtube",
  },
  {
    value: 11,
    label: "Nguồn resales",
  },
  {
    value: 12,
    label: "Nguồn app",
  },
  {
    value: 13,
    label: "Nguồn khách hàng BOD",
  },
  {
    value: 14,
    label: "Nguồn khách hàng MXG",
  },
];

const RelationList: any = [
  {
    value: "father",
    label: "Cha",
  },
  {
    value: "mother",
    label: "Mẹ",
  },
  {
    value: "grandfather",
    label: "Ông",
  },
  {
    value: "Grandmother",
    label: "Bà",
  },
  {
    value: "olderbrother",
    label: "Anh trai",
  },
  {
    value: "brother",
    label: "Em trai",
  },
  {
    value: "youngersister",
    label: "Em gái",
  },
  {
    value: "other",
    label: "Khác",
  },
];

const initialParams = {
  page: 1,
  limit: 25,
  filter: {
    page: 1,
    limit: 25,
    from: moment().startOf('day').valueOf(),
    to: moment().endOf("day").valueOf(),
  }
}
const List = (props: any) => {
  const {
    from,
    dataFromExam,
    setDataFromExam,
    closeModal,
    fetchCustomerExam,
    onUpdateReception,
    dataFromBooking,
    useful
  } = props;
  const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
  const searchPrams = queryString.parse(props?.location?.search);
  const [tabActive, setTabActive] = useState((searchPrams?.tab) || 'info');
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(props?.match?.params?.id);
  const [onlyView, setOnlyView] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [totalElementsMonitor, setTotalElementsMonitor] = useState(0);
  const [data, setData] = useState<any>({
    sex: "male",
  });
  const [rela, setRela] = useState<any>([
    {
      name: "",
      phone: "",
      relationship: null,
      cccd: "",
    },
  ]);
  const rootUser = props?.user

  const [address, setAddress] = useState<any>([]);
  const [isInfo, setIsInfo] = useState<any>(true);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [type, setType] = useState(props?.match?.params?.action);
  const [action, setAction] = useState<any>();
  const [province, setProvince] = useState<any>([]);
  const [district, setDistrict] = useState<any>([]);
  const [ward, setWard] = useState<any>([]);
  const [userNutri, setUserNutri] = useState<any>([]);
  const [history, setHistory] = useState<any>();
  const [dataAction, setDataAction] = useState<any>();
  const [monitor, setMonitor] = useState<any>({
    day: moment().startOf("day").unix() * 1000,
    created_uid: rootUser.id
  });
  const [dataMonitor, setDataMonitor] = useState<any>();

  let columnOrder = props?.columnOrder || COLUMN_ORDER

  // if (columnOrder?.filter((item: any) => item?.value === 'doctor_id.name')?.length === 0) {
  //   columnOrder = COLUMN_ORDER
  // }

  useEffect(() => {
    if (id && id !== "add") {
      loadData();
      document.title = "Chỉnh sửa khách hàng";
    } else {
      document.title = "Thêm mới khách hàng";
    }
    if (type === "view") {
      setOnlyView(true);
      loadHistory(id);
      loadActionList(id);
      document.title = "Chi tiết khách hàng";
    }
  }, [id]);

  useEffect(() => {
    fetchProvince();
    fetchUser();
  }, []);

  useEffect(() => {
    if (dataFromBooking?.id) {
      setId(dataFromBooking?.id);
    } else if (dataFromBooking?.name) {
      setData({
        name: dataFromBooking?.name,
        sex: dataFromBooking?.sex,
        birthday: dataFromBooking?.birthday,
        phone: dataFromBooking?.phone,
        customer_care_uid: dataFromBooking?.customer_care_uid
          ? {
            id: dataFromBooking?.customer_care_uid,
          }
          : undefined,
      });
      dataFromBooking?.customer_guardian_name &&
        setRela([
          {
            name: dataFromBooking?.customer_guardian_name,
            phone: "",
            relationship: null,
          },
        ]);
      setIsInfo(dataFromBooking?.customer_guardian_name ? true : false);
    }
  }, [dataFromBooking]);

  const setFilter = (value: {}) => {
    setParams((prevState: any) => ({
      ...prevState,
      filter: value
    }));
  }

  useEffect(() => {
    setFilterParams({
      page: page?.page,
      limit: limit?.limit,
      ...filter,
    });
  }, [data, filter])

  useEffect(() => {
    if (data?.id) {
      getOrderpackage(data?.id)
    }
  }, [data?.id, filter])

  useEffect(() => {
    getMonitor()
  }, [data?.id, filter])

  const handleActionModal = (item: any) => {
    setAction(item);
    setIsOpen(true);
  };

  const fetchUser = async () => {
    const url = `${baseUrl}/user`;
    const params = {
      limit: 500,
      status: 1,
    };
    setLoading(true);
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      let Arr: any = [];
      response.response?.data?.map((e: any) => {
        Arr?.push({
          value: e?.id,
          label: e?.name,
          ...e,
        });
      });
      setUserNutri(Arr);
    }
  };

  const fetchProvince = async () => {
    const url = `${baseUrl}/address/provinces`;
    const params = {
      page: 1,
      limit: 100,
    };
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response?.data !== undefined) {
      let ListArr: any = [];
      response.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: Number(e?.code),
          label: e?.name,
        });
      });
      setProvince(ListArr);
    }
  };

  const fetchDistrict = async (province_code: any) => {
    const url = `${baseUrl}/address/districts`;
    const params = {
      page: 1,
      limit: 500,
      province_code: province_code,
    };
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response?.data !== undefined) {
      let ListArr: any = [];
      response.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: Number(e?.code),
          label: e?.full_name,
        });
      });
      setDistrict(ListArr);
    }
  };

  const fetchWard = async (district_code: any) => {
    const url = `${baseUrl}/address/wards`;
    const params = {
      page: 1,
      limit: 500,
      district_code: district_code,
    };
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response?.data !== undefined) {
      let ListArr: any = [];
      response.response?.data?.map((e: any) => {
        ListArr?.push({
          ...e,
          value: Number(e?.code),
          label: e?.full_name,
        });
      });
      setWard(ListArr);
    }
  };

  const loadData = async () => {
    const url = `${baseUrl}/customer/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response;
      resData?.provinces_code?.code && fetchDistrict(resData?.provinces_code?.code);
      resData?.district_code?.code && fetchWard(resData?.district_code?.code);
      const dataTemp: any = {
        ...resData,
        provinces_code: {
          value: resData?.provinces_code?.code,
          code: resData?.provinces_code?.code,
          label: resData?.provinces_code?.full_name,
        },
        district_code: {
          value: resData?.district_code?.code,
          code: resData?.district_code?.code,
          label: resData?.district_code?.full_name,
        },
        wards_code: {
          value: resData?.wards_code?.code,
          code: resData?.wards_code?.code,
          label: resData?.wards_code?.full_name,
        },
        source: { value: resData?.source },
      };
      const rela =
        resData?.customer_guardians?.length != 0
          ? resData?.customer_guardians
          : [];
      if (dataFromBooking?.name) {
        dataTemp.name = dataFromBooking?.name;
        dataTemp.sex = dataFromBooking?.sex;
        dataTemp.birthday = dataFromBooking?.birthday;

        if (dataFromBooking.customer_care_uid) {
          dataTemp.customer_care_uid = {
            id: dataFromBooking?.customer_care_uid,
          };
        }
        dataFromBooking?.customer_guardian_name &&
          rela.push({
            name: dataFromBooking?.customer_guardian_name,
            phone: "",
            relationship: null,
          });
      }
      setIsInfo(rela?.length != 0 ? true : false);
      if (rela?.length === 0)
        rela.push({
          name: "",
          phone: "",
          relationship: null,
        });
      setRela(rela);
      setData(dataTemp);
      setAddress(resData?.address || []);
      setMonitor({ ...monitor, customer_id: dataTemp?.id })
    }
  };

  const loadHistory = async (id: number) => {
    const url = `${baseUrl}/customer/history/${id}`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response?.data;
      setHistory(resData);
    }
  };

  const loadActionList = async (id: number) => {
    const url = `${baseUrl}/customer-action`;
    setLoading(true);
    let response: any = await APIClient.GET(url, {
      customer_id: id,
    });
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response?.data;
      setDataAction(resData);
    }
  };


  const setFilterParams = (params: any) => {
    var filterParams = "";
    Object.keys(params).map(function (item, i) {
      if (i === 0) {
        if (params[item])
          filterParams = filterParams + "?" + item + "=" + params[item];
      } else {
        if (params[item])
          filterParams = filterParams + "&" + item + "=" + params[item];
      }
    });
    props.history?.push({
      search: filterParams,
    });
  };

  const [orderspackage_services, setOrderspackage_services] = useState<any>()
  const [orderpackage, setOrderpackage] = useState<any>()
  const getOrderpackage = async (id: any) => {
    const params = {
      // ...filter,
      page: filter?.page,
      limit: filter?.limit
    }
    const url = `${baseUrl}/customer/orderpackage/${id}`
    setLoading(true)
    let response: any = await APIClient.GET(url, params);
    setLoading(false)
    if (response.error !== undefined) {
    } else if (response.response?.data !== undefined) {
      let Arr: any = [];
      response.response?.data?.map((e: any) => {
        e?.orderspackage_services?.map((a: any) => {
          Arr?.push({
            ids: e?.id,
            value: a?.id,
            label: a?.name,
            ...a,
            ...e,
          });
        })
      });
      setOrderspackage_services(Arr)
      setOrderpackage(response.response?.data);
      setTotalElements(response.response?.total)
    }
  }

  const getMonitor = async () => {
    const params = {
      ...filter,
      page: filter?.page,
      limit: filter?.limit,
      customer_id: data?.id,
    }
    const url = `${baseUrl}/customer-companion-tracking`;
    setLoading(true);
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error);
    } else if (response.response !== undefined) {
      setTotalElementsMonitor(response.response?.total)
      setDataMonitor(response?.response?.data)
    }
  }


  return (
    <div style={{ paddingBottom: 50 }}>
      <React.Fragment>
        {!from && (
          <PageTitle
            breadCrumbItems={[
              {
                label: `${type == "view"
                  ? "Xem chi tiết"
                  : id
                    ? "Chỉnh sửa"
                    : "Thêm mới"
                  } hồ sơ khách hàng`,
                active: true,
              },
            ]}
            title={`${type == "view" ? "Xem chi tiết" : id ? "Chỉnh sửa" : "Thêm mới"
              } hồ sơ khách hàng`}
          />
        )}
        {type == "view" && <Row>
          <Col md={12}>
            <div className="mb-3">
              <NavTabNutri
                {...props}
                tabList={TABS?.reduce((prev: any, item: any) => {
                  if (!(!id && item?.value === 3)) {
                    prev = [...prev, item];
                  }
                  return prev;
                }, [])}
                setTab={(tab: any) => setTabActive(tab)}
                tab={tabActive || 0}
                classes="mt-3 mb-0 nav-tab-full"
              />
            </div>
          </Col>
        </Row>}
        {
          tabActive === 'info' &&
          <ContentPage
            useful={useful}
            user={props?.user}
            data={data}
            address={address}
            setAddress={setAddress}
            setData={(val: any) => setData(val)}
            province={province}
            district={district}
            ward={ward}
            fetchDistrict={(val: any) => fetchDistrict(val)}
            fetchWard={(val: any) => fetchWard(val)}
            onlyView={onlyView}
            id={id}
            type={type}
            action={action}
            handleActionModal={(data: any) => handleActionModal(data)}
            from={from}
            rela={rela}
            setRela={(data: any) => setRela(data)}
            isInfo={isInfo}
            setIsInfo={(data: any) => setIsInfo(data)}
            dataFromExam={dataFromExam}
            setDataFromExam={setDataFromExam}
            closeModal={closeModal}
            fetchCustomerExam={fetchCustomerExam}
            onUpdateReception={onUpdateReception}
            userNutri={userNutri}
            loadData={() => loadData()}
            loadActionList={() => loadActionList(id)}
            history={history}
            dataAction={dataAction}
          />}
        {
          tabActive === 'service' &&
          <Service
            columnOrder={columnOrder}
            totalElements={totalElements}
            useful={useful}
            user={props?.user}
            filter={filter}
            setFilter={setFilter}
            data={data}
            orderspackage_services={orderspackage_services}
            address={address}
            setAddress={setAddress}
            setData={(val: any) => setData(val)}
            province={province}
            district={district}
            ward={ward}
            fetchDistrict={(val: any) => fetchDistrict(val)}
            fetchWard={(val: any) => fetchWard(val)}
            onlyView={onlyView}
            id={id}
            type={type}
            action={action}
            handleActionModal={(data: any) => handleActionModal(data)}
            from={from}
            rela={rela}
            setRela={(data: any) => setRela(data)}
            isInfo={isInfo}
            setIsInfo={(data: any) => setIsInfo(data)}
            dataFromExam={dataFromExam}
            setDataFromExam={setDataFromExam}
            closeModal={closeModal}
            fetchCustomerExam={fetchCustomerExam}
            onUpdateReception={onUpdateReception}
            userNutri={userNutri}
            loadData={() => loadData()}
            loadActionList={() => loadActionList(id)}
            dataAction={dataAction}
          />}
        {
          tabActive === 'chart' &&
          <ChartPage
            user={props?.user}
            data={data}
            address={address}
            setAddress={setAddress}
            setData={(val: any) => setData(val)}
            province={province}
            district={district}
            ward={ward}
            fetchDistrict={(val: any) => fetchDistrict(val)}
            fetchWard={(val: any) => fetchWard(val)}
            onlyView={onlyView}
            id={id}
            type={type}
            action={action}
            handleActionModal={(data: any) => handleActionModal(data)}
            from={from}
            rela={rela}
            setRela={(data: any) => setRela(data)}
            isInfo={isInfo}
            setIsInfo={(data: any) => setIsInfo(data)}
            dataFromExam={dataFromExam}
            setDataFromExam={setDataFromExam}
            closeModal={closeModal}
            fetchCustomerExam={fetchCustomerExam}
            onUpdateReception={onUpdateReception}
            userNutri={userNutri}
            loadData={() => loadData()}
            loadActionList={() => loadActionList(id)}
            history={history}
            dataAction={dataAction}
          />
        }
        {
          tabActive === 'monitor' &&
          <Monitor
            rootUser={rootUser}
            handleActionModal={(data: any) => handleActionModal(data)}
            customer_id={data?.id}
            dataMonitor={dataMonitor}
            setFilter={setFilter}
            filter={filter}
            setMonitor={setMonitor}
            totalElements={totalElementsMonitor}
          />
        }
        <ModalPopup
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
        >
          {action?.type === "addReceipts" ? (
            <ReceiptsAdd
              closeModal={() => setIsOpen(false)}
              action={action}
              loadData={() => getOrderpackage(data?.id)}
              orders_id_service_package={action?.orders_id}
            />
          ) : action?.type === "addPayment" ? (
            <PaymentAdd
              closeModal={() => setIsOpen(false)}
              action={action}
              loadData={() => loadData()}
              customer_id={id}
            />
          ) : action?.type === "addAction" || action?.type === "editAction" ? (
            <ActionAdd
              closeModal={() => setIsOpen(false)}
              action={action}
              loadData={() => loadActionList(id)}
              customer_id={id}
            />
          ) : action?.type === "addAddress" ||
            action?.type === "editAddress" ? (
            <AddressAdd
              closeModal={() => setIsOpen(false)}
              action={action}
              address={address}
              setAddress={setAddress}
              customer_id={id}
            />
          ) : (
            <RenderActionModal modalIsOpen={modalIsOpen}
              {...props}
              setIsOpen={setIsOpen}
              id={id}
              monitor={monitor}
              setMonitor={setMonitor}
              closeModal={() => setIsOpen(false)}
              filter={filter}
              action={action}
              loadData={() => loadData()}
              loadActionList={() => loadActionList(id)}
              handleActionModal={(data: any) => handleActionModal(data)}
              rootUser={rootUser}
              getMonitor={getMonitor}
              columnOrder={columnOrder}

            />
          )}
        </ModalPopup>
        {loading && <Loader />}
      </React.Fragment>
    </div>
  );
};

const ContentPage = (props: any) => {
  const {
    data,
    type,
    setData,
    fetchDistrict,
    fetchWard,
    province,
    district,
    ward,
    onlyView,
    id,
    action,
    handleActionModal,
    loadData,
    address,
    setAddress,
    from,
    rela,
    useful,
    setRela,
    isInfo,
    setIsInfo,
    dataFromExam,
    setDataFromExam,
    closeModal,
    fetchCustomerExam,
    onUpdateReception,
    userNutri,
    setCheckData
  } = props;
  const [checkS, setCheckS] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataChangeCount, setDataChangeCount] = useState(0);
  const [presenter, setPresenter] = useState<any>();
  const router = useHistory();
  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target;
    if (value === " ") return;
    if (name == "user_aff_phone") {
      value = value.replace(/\D/g, '')
      value = value.slice(0, 12);
    }
    if (name === "phone" || name === "guardian_phone") {
      value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "");
    }
    if (value?.length > 1000) return;
    setData({
      ...data,
      [name]: value,
    });
  };
  const [filterPhone, setFilterPhone] = useState<any[]>([]);

  useEffect(() => {
    customer()
  }, [data?.phone])

  useEffect(() => {
    loadDataPersenter();
  }, [])

  const handleChangeDate = (date: any) => {
    setData({
      ...data,
      birthday: date[0] ? moment(date[0]) : undefined,
    });
  };

  // const handleKeyDown = (e: any) => {
  //   if (e.key === 'Backspace') {
  //     const value = e.target.value;
  //     // if (value.length > 6) {
  //     //   if (e.target.selectionStart)
  //     //   e.target.value = value.substring(0, 6);
  //     // } else if (value.length > 3) {
  //     //   e.target.value = value.substring(0, 3);
  //     // } else {
  //     //   e.target.value = '';
  //     // }
  //     // if (value.length === 3) {
  //     //   e.target.value = '';
  //     // }
  //     // if (value.length === 6 && value.indexOf('/') === 2) {
  //     //   e.target.value = value.substring(0, 3);
  //     // }
  //   }
  // };

  // Thêm mới Rela
  const handleAddRela = () => {
    const newRelativeUser = {
      name: "",
      phone: "",
      relationship: null,
    };
    setRela([...rela, newRelativeUser]);
  };

  // Chỉnh sửa Rela
  const handleUpdateRela = (dataRela: any, index: number) => {
    let newRelativeUser = cloneDeep(rela);
    newRelativeUser[index] = dataRela;
    setRela(newRelativeUser);
    setCheckS(true);
  };

  // Xóa Rela
  const handleRemoveRela = (index: number) => {
    let newRelativeUser = cloneDeep(rela);
    newRelativeUser.splice(index, 1);
    setRela(newRelativeUser);
  };

  const customer = async () => {
    const url = `${baseUrl}/customer`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const filteredData = response.response?.data.filter((item: any) => {
        if (data?.id) {
          return item?.phone === data?.phone && data?.id !== item?.id;
        } else {
          return item?.phone === data?.phone;
        }
      });
      setFilterPhone((prevFilterPhone) => [...prevFilterPhone, ...filteredData]);
    }

  }
  const validationFrom = () => {
    if (isEmpty(data.name)) {
      toast.warning("Tên khách hàng không được để trống!");
      return false;
    }
    if (isEmpty(data.birthday)) {
      toast.warning("Ngày sinh không được để trống!");
      return false;
    }
    if (isEmpty(data.phone)) {
      toast.warning("Số điện thoại không được để trống!");
      return false;
    }
    if (
      // !TextUtils.validatePhone(data.phone) || data.phone?.length > 20
      data?.phone?.length > 20 && data?.phone?.length < 9
    ) {
      toast.warning("Số điện thoại không đúng!");
      return false;
    }

    const checkAddress = address?.reduce((prev: any, item: any) => {
      if (item?.status === 1) {
        prev = [...prev, item];
      }
      return prev;
    }, []);
    // if(checkAddress?.length === 0){
    //     toast.warning('Vui lòng chọn địa chỉ nhạn hàng mặc định');
    //     return false
    // }
    // if(checkAddress?.length > 1){
    //     toast.warning('Vui lòng chọn duy nhất một địa chỉ nhận hàng mặc định');
    //     return false
    // }
    //tạm htowif bỏ cho kashch hàng nhập liệu, vì ko thể lấy thông tin địa chỉ của kahsh hàng
    // if (!data.provinces_code) {
    //     toast.warning('Tỉnh/ Thành phố không được để trống!');
    //     return false
    // }
    // if (!data.district_code) {
    //     toast.warning('Quận/ Huyện không được để trống!');
    //     return false
    // }
    // if (!data.wards_code) {
    //     toast.warning('Phường/ Xã không được để trống!');
    //     return false
    // }
    // if (isEmpty(data.street)) {
    //     toast.warning('Địa chỉ chi tiết không được để trống!');
    //     return false
    // }
    // if (isEmpty(data.source)) {
    //     toast.warning('Nguồn khách hàng không được để trống!');
    //     return false
    // }
    if (isInfo) {
      const validateRela = rela?.map((e: any, index: number) => {
        if (e?.name === "") {
          toast.warning(`Tên người thân #${index + 1} không được để trống!`);
          return false;
        }
        if (isEmpty(e?.relationship)) {
          toast.warning(
            `Quan hệ người thân #${index + 1} không được để trống!`
          );
          return false;
        }
        if (e?.phone === "") {
          toast.warning(
            `Số điện thoại người thân #${index + 1} không được để trống!`
          );
          return false;
        }
        if (
          // e?.phone?.length != 10 || !TextUtils.validatePhone(e?.phone)
          e?.phone?.length > 20 && e?.phone?.length < 9
        ) {
          toast.warning(`Số điện thoại người thân #${index + 1} không đúng!`);
          return false;
        }
        // if (e?.cccd === "") {
        //   toast.warning(`Số CCCD hoặc CMT người thân không được để trống`);
        //   return false;
        // }
      });

      const checkRela = validateRela?.findIndex((e: any) => e === false);
      if (checkRela > -1) {
        return false;
      }
    }

    return true;
  };

  const CreateRelation = async (dataRela: any, customerId: any) => {
    const url = `${baseUrl}/customer-guardian`;
    const params = {
      customer_id: customerId,
      ...dataRela,
    };
    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
    }
  };

  const EditRelation = async (dataRela: any, customerId: any) => {
    const url = `${baseUrl}/customer-guardian/${dataRela?.id}`;
    const params = {
      customer_id: customerId,
      ...dataRela,
    };
    let response: any = await APIClient.PUT(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
    }
  };

  const deleteRelation = async (dataRela: any) => {
    const url = `${baseUrl}/customer-guardian/${dataRela?.id}`;
    let response: any = await APIClient.DELETE(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      // loadData()
    }
  };

  const handleSubmit = async () => {
    if (!validationFrom()) return;
    const newAddress = address?.reduce((prev: any, item: any) => {
      prev = [
        ...prev,
        {
          ...item,
          district_code: item?.district_code?.code,
          provinces_code: item?.provinces_code?.code,
          wards_code: item?.wards_code?.code,
        },
      ];
      return prev;
    }, []);
    setLoading(true);
    const url = `${baseUrl}/customer`;
    const params = {
      ...data,
      provinces_code: data?.provinces_code?.code,
      district_code: data?.district_code?.code,
      wards_code: data?.wards_code?.code,
      birthday: moment(data?.birthday).valueOf(),
      source: data?.source?.value,
      customer_care_uid: data?.customer_care_uid?.id,
      address: newAddress,
      customer_debts: undefined,
      examinations: undefined,
      user_aff_phone: data?.user_aff_phone,
    };

    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      if (isInfo) {
        rela?.map((e: any) => {
          CreateRelation(e, response.response?.id);
        });
      }
      if (from == "exam") {
        //Thêm mới khách hàng từ màn phiếu khám
        const reponseData = response.response;
        let responseInfo: any = await APIClient.GET(`${baseUrl}/customer/${reponseData?.id}`);
        const reponseDataInfo = responseInfo.response;
        let shipping_address = ''
        let address_default = reponseDataInfo?.address?.filter((itemFil: any) => itemFil?.status === 1)
        if (address_default[0]) {
          address_default = address_default[0]
          shipping_address = address_default?.street || ""
          if (address_default?.wards_code?.name) shipping_address += ", " + address_default?.wards_code?.name
          if (address_default?.district_code?.name) shipping_address += ", " + address_default?.district_code?.name
          if (address_default?.provinces_code?.name) shipping_address += ", " + address_default?.provinces_code?.name
        }
        setDataFromExam({
          ...dataFromExam,
          customer_id: {
            id: reponseDataInfo?.id,
            name: reponseDataInfo?.name,
            phone: reponseDataInfo?.phone,
            birthday: reponseDataInfo?.birthday,
            sex: reponseDataInfo?.sex,
            street: reponseDataInfo?.street,
            wards_code: reponseDataInfo?.wards_code,
            provinces_code: reponseDataInfo?.provinces_code,
            district_code: reponseDataInfo?.district_code,
            address: reponseDataInfo?.address || [],
            address_default: address_default || {},
          },
          shipping_address,
          orderspackage: ''
        });
        fetchCustomerExam && fetchCustomerExam();
        closeModal();
      } else if (from == 'servicepackage') {
        //Thêm mới khách hàng từ màn thẻ dịch vụ
        const reponseData = response.response;
        let responseInfo: any = await APIClient.GET(`${baseUrl}/customer/${reponseData?.id}`);
        const reponseDataInfo = responseInfo.response;

        setDataFromExam({
          ...dataFromExam,
          customer_id: {
            id: reponseDataInfo?.id,
            name: reponseDataInfo?.name,
            phone: reponseDataInfo?.phone,
          },
        });

        fetchCustomerExam && fetchCustomerExam();
        closeModal();
      }
      else if (from == 'addcustomerservice') {
        //Thêm mới khách hàng từ màn thẻ dịch vụ(gói thẻ dịch vụ)
        const reponseData = response.response;
        let responseInfo: any = await APIClient.GET(`${baseUrl}/customer/${reponseData?.id}`);
        const reponseDataInfo = responseInfo.response;

        setDataFromExam({
          ...dataFromExam,
          customer_ids: [...dataFromExam?.customer_ids,
          {
            ...reponseDataInfo,
            value: reponseDataInfo?.id,
            label: reponseDataInfo?.name
          }
          ],
        });

        fetchCustomerExam && fetchCustomerExam();
        closeModal();
      }
      else if (onUpdateReception) {
        const reponseData = response.response;
        onUpdateReception && onUpdateReception(reponseData?.id);
        closeModal();
      } else {
        toast.success("Tạo mới khách hàng thành công");
        router?.push("/customer/list");
      }
    }
  };

  const handleEdit = async () => {
    if (!validationFrom()) return;
    const newAddress = address?.reduce((prev: any, item: any) => {
      prev = [
        ...prev,
        {
          ...item,
          district_code: item?.district_code?.code,
          provinces_code: item?.provinces_code?.code,
          wards_code: item?.wards_code?.code,
        },
      ];
      return prev;
    }, []);
    setLoading(true);
    const url = `${baseUrl}/customer/${id}`;
    const params = {
      ...data,
      provinces_code: data?.provinces_code?.code,
      district_code: data?.district_code?.code,
      wards_code: data?.wards_code?.code,
      birthday: moment(data?.birthday).valueOf(),
      source: data?.source?.value,
      customer_care_uid: data?.customer_care_uid?.id,
      address: newAddress,
      customer_debts: undefined,
      examinations: undefined,
      user_aff_phone: data?.user_aff_phone,
    };
    delete params?.created_uid;
    delete params?.created_time;
    delete params?.id;
    let response: any = await APIClient.PUT(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      if (isInfo) {
        //Nếu Chọn có thông tin thì tạo hoặc sửa liên hệ
        rela?.map((e: any) => {
          if (e?.id) {
            EditRelation(e, response.response?.id);
          } else {
            CreateRelation(e, response.response?.id);
          }
        });
      } else {
        //Nếu Chọn không có thông tin thì xóa liên hệ luôn
        rela?.map((e: any) => {
          if (e?.id) {
            deleteRelation(e);
          }
        });
      }
      if (onUpdateReception) {
        closeModal();
        const reponseData = response.response;
        onUpdateReception && onUpdateReception(reponseData?.id);
      } else {
        toast.success("Chỉnh sửa khách hàng thành công");
        router?.push("/customer/list");
      }
    }
  };

  const getAgeLabel = () => {
    if (!data?.birthday) return null;
    const months = moment(data?.birthday).format("MM");
    const years = moment(data?.birthday).format("YYYY");
    const monthNow = moment().format("MM");
    const yearNow = moment().format("YYYY");
    let ageYear: number = 0;
    let ageMonth: number = 0;
    if (months > monthNow) {
      ageYear = Number(yearNow) - Number(years) - 1;
      ageMonth = 12 - Number(months) + Number(monthNow);
    } else {
      ageYear = Number(yearNow) - Number(years);
      ageMonth = Number(monthNow) - Number(months);
    }
    if (ageYear <= 5) {
      return `${ageYear} tuổi ${ageMonth} tháng (${Number(ageYear) * 12 + Number(ageMonth)
        } tháng)`;
    } else {
      return `${ageYear} tuổi ${ageMonth} tháng`;
    }
  };

  const handleSetAddressDefault = (index: number) => {
    let newAddress: any = cloneDeep(address);
    newAddress = newAddress?.reduce((prev: any, item: any) => {
      item.status = 0;

      prev = [...prev, item];
      return prev;
    }, []);
    newAddress[index].status = 1;
    setAddress([...newAddress]);
  };
  useEffect(() => {
    if (dataChangeCount >= 1) {
      setCheckS(true);
    }
    setDataChangeCount(dataChangeCount + 1);
  }, [data]);
  const userAffPhones = filterPhone.map((item) => item?.user_aff_phone).filter(Boolean); // filter để lấy ra tất cả mã giới thiệu
  const userAffPhonesString = userAffPhones.join(', '); // lấy mã giới thiệu gộp lại với nhau cách nhau dấu phẩy

  // Người giới thiệu nè
  const [queryPersenter, setQueryPersenter] = useState('');

  const handleInputChangePersenter = (newValue: any) => {
    setQueryPersenter(newValue);
    return newValue;
  };

  const loadPersenterSearch = async () => {
    setLoading(true)
    let response: any = await APIClient.GET(`${baseUrl}/user-aff`, {
      page: 1,
      limit: 20,
      name: queryPersenter,
    });
    setLoading(false)
    if (response.response?.data !== undefined) {
      let Arr: any = [];
      response.response?.data?.map((e: any) => {
        Arr?.push({
          value: e?.id,
          label: e?.name,
          ...e,
        });
      });
      return Arr
    }
  };

  const loadDataPersenter = async () => {
    const url = `${baseUrl}/user-aff`
    const params = {
      limit: 100,
    }
    setLoading(true);
    let response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error?.error_description);
    } else if (response.response !== undefined) {
      let Arr: any = [];
      response.response?.data?.map((e: any) => {
        Arr?.push({
          value: e?.id,
          label: e?.name,
          ...e,
        });
      });
      setPresenter(Arr);
    }
  }

  const customOptionPersenter = ({ innerProps, data }: any) => {
    return (
      <div {...innerProps} style={{ display: 'flex', justifyContent: 'space-between', padding: "10px", borderBottom: "solid 1px #DCDCDC", cursor: 'pointer' }}>
        {`${data?.name} - ${data?.phone}`}
      </div>
    );
  }
  const getLabelStatus = () => {
    switch (data?.status) {
      case 1: {
        return <span className="ml-2 label-status bg-success">Đã hoạt động!</span>
        break;
      }
      default: {
        return null
        break;
      }
    }
  }

  return (
    <PageContent
      style={
        from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice'
          ? { width: "900px", maxHeight: "80vh", overflowX: "hidden", borderRadius: "15px" }
          : {}
      }
      className={onlyView ? "only-view" : ""}
    >
      <Row>
        <Col md={from == "exam" || from == 'servicepackage' || from == 'addcustomerservice' || from == 'reception' ? 12 : 6}>
          <PageBody >
            {
              useful == true &&
              <div className="text-center sticky-position modal-header" style={{ marginTop: "-20px", position: "sticky", backgroundColor: "white" }}>
                <h5 className="modal-title" id="modal-action-title">
                  Thêm mới khách hàng
                </h5>
                <button
                  onClick={() => {
                    if (checkS) {
                      props?.handleActionModal({ type: "close" })
                    } else {
                      setLoading(false);
                      props.closeModal();
                    }
                  }}
                  type="button"
                  className="close"
                >
                  {" "}
                  <span aria-hidden="true">×</span>{" "}
                </button>
              </div>
            }
            <div className="nutri-title mb-3 flex-row-center" style={useful ? { marginTop: "20px" } : {}} >
              <div>
                Thông tin khách hàng <span>{getLabelStatus()}</span>
                {data?.customer_rank_id && (
                  <span className="ml-2 label-status bg-info">
                    {data?.customer_rank_id?.rank_name}
                  </span>
                )}
              </div>
            </div>
            <Row>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Mã khách hàng</Label>
                  <Input
                    type="text"
                    value={data?.code}
                    onChange={(e: any) => handleChangeInput(e)}
                    name="code"
                    placeholder={
                      type == "view" && !data?.code
                        ? "---"
                        : "Nhập mã khách hàng"
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>
                    <span>*</span>Tên khách hàng
                  </Label>
                  <Input
                    type="text"
                    value={data?.name}
                    onChange={(e: any) => handleChangeInput(e)}
                    name="name"
                    placeholder="Nhập tên khách hàng"
                  />
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>
                    <span>*</span>Ngày sinh
                  </Label>
                  <Flatpickr
                    value={data?.birthday ? moment(data.birthday).format("DD/MM/YYYY") : ''}
                    onChange={(date) => {
                      handleChangeDate(date)
                    }}

                    onReady={(selectedDates, dateStr, instance) => {
                      const input = instance._input;
                      input.addEventListener("input", (e: any) => {
                        let inputValue = e.target.value;
                        // Loại bỏ tất cả các ký tự không phải số
                        inputValue = inputValue.replace(/[^0-9/]/g, '');
                        let elements = inputValue.split('/');
                        if (elements.length < 3) {
                          // chưa có gạch nào
                          if (inputValue.length === 2 && inputValue.indexOf('/') === -1) {
                            inputValue = inputValue + '/';
                          }
                          // có một gạch
                          if (elements.length === 2) {
                            if (elements[0].length === 2 && elements[1].length === 2) {// "12/02 -> 12/02/"
                              inputValue += '/';
                            }
                          }
                        }
                        e.target.value = inputValue;
                      });
                    }}
                    options={{
                      locale: Vietnamese,
                      allowInput: true,
                      dateFormat: "d/m/Y",
                      altInputClass: "date-range",
                      maxDate: 'today',

                    }}
                    placeholder="dd/mm/yyyy"
                  >
                  </Flatpickr>
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Tuổi</Label>
                  <ValueText>
                    {CalcUtils.calculateAge(data?.birthday)}
                  </ValueText>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>
                    <span>*</span> Giới tính
                  </Label>
                  <div className="d-flex align-items-center">
                    <Row style={{ width: "100%" }}>
                      <Col xl={6}>
                        <div
                          className={
                            data?.sex == "male"
                              ? "nutri-radio active"
                              : "nutri-radio"
                          }
                          onClick={() =>
                            type == "view"
                              ? {}
                              : setData({ ...data, sex: "male" })
                          }
                        >
                          <div className="icon"></div>
                          <div className="label">Nam</div>
                        </div>
                      </Col>
                      <Col xl={6}>
                        <div
                          className={
                            data?.sex == "female"
                              ? "nutri-radio active"
                              : "nutri-radio"
                          }
                          onClick={() =>
                            type == "view"
                              ? {}
                              : setData({ ...data, sex: "female" })
                          }
                        >
                          <div className="icon"></div>
                          <div className="label">Nữ</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>
                    <span>*</span> Số điện thoại
                  </Label>
                  {type === "view" ? (
                    <ValueText>{data?.phone}</ValueText>
                  ) : (
                    <InputGroup>
                      <Input
                        type="text"
                        value={data?.phone}
                        onChange={(e: any) => handleChangeInput(e)}
                        name="phone"
                        placeholder="Nhập số điện thoại"
                      />
                      {type != "view" && (
                        <InputGroupAddon
                          addonType="append"
                          className="d-flex align-items-center"
                        >
                          <img
                            src={PhoneImageIcon}
                            width={18}
                            height={18}
                            alt=""
                          />
                        </InputGroupAddon>
                      )}
                    </InputGroup>
                  )}
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Email</Label>
                  <Input
                    type="text"
                    value={data?.email}
                    onChange={(e: any) => handleChangeInput(e)}
                    name="email"
                    placeholder={
                      type == "view" && !data?.email ? "---" : "Nhập Email"
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Nhân viên chăm sóc</Label>
                  <Select
                    placeholder="Chọn"
                    className="react-select mb-2"
                    classNamePrefix="react-select"
                    maxMenuHeight={250}
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                      setData({ ...data, customer_care_uid: val });
                    }}
                    value={userNutri?.filter(
                      (option: any) =>
                        data?.customer_care_uid?.id == option.value
                    )}
                    options={userNutri}
                  ></Select>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 4 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  {/* <Label><span>*</span>Tỉnh/ Thành phố</Label> */}
                  <Label>Tỉnh/ Thành phố</Label>
                  <Select
                    placeholder="Chọn Tỉnh/ Thành phố"
                    className="react-select mb-2"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                      setData({
                        ...data,
                        provinces_code: val,
                        district_code: null,
                        wards_code: null,
                      });
                      fetchDistrict(val?.code);
                    }}
                    value={province?.filter(
                      (option: any) =>
                        data?.provinces_code?.code == option.value
                    )}
                    options={province}
                  ></Select>
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 4 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  {/* <Label><span>*</span>Quận/ Huyện</Label> */}
                  <Label>Quận/ Huyện</Label>
                  <Select
                    placeholder="Chọn Quận/ Huyện"
                    className="react-select mb-2"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                      setData({
                        ...data,
                        district_code: val,
                        wards_code: null,
                      });
                      fetchWard(val?.code);
                    }}
                    value={district?.filter(
                      (option: any) => data?.district_code?.code == option.value
                    )}
                    options={district}
                  ></Select>
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 4 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  {/* <Label><span>*</span>Phường/ Xã</Label> */}
                  <Label>Phường/ Xã</Label>
                  <Select
                    placeholder="Chọn Phường/ Xã"
                    className="react-select mb-2"
                    classNamePrefix="react-select"
                    isDisabled={onlyView}
                    onChange={(val: any) => {
                      setData({ ...data, wards_code: val });
                    }}
                    value={ward?.filter(
                      (option: any) => data?.wards_code?.code == option.value
                    )}
                    options={ward}
                  ></Select>
                </FormGroup>
              </Col>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 12 : 3} xs={12}>
                <FormGroup className="nutri-form">
                  {/* <Label><span>*</span>Địa chỉ chi tiết</Label> */}
                  <Label>Địa chỉ chi tiết</Label>
                  <Input
                    type="text"
                    value={data?.street}
                    onChange={(e: any) => handleChangeInput(e)}
                    name="street"
                    placeholder="Nhập địa chỉ chi tiết"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 6} xs={12}>
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label>Nguồn khách hàng</Label>
                      <Select
                        placeholder="Chọn"
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        maxMenuHeight={250}
                        isDisabled={onlyView}
                        onChange={(val: any) => {
                          setData({ ...data, source: val });
                        }}
                        value={SourceList?.filter(
                          (option: any) => data?.source?.value == option.value
                        )}
                        options={SourceList}
                      ></Select>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label> Mã người giới thiệu</Label>
                      <AsyncSelect
                        className="react-select mb-2 react-select2-line"
                        classNamePrefix="react-select"
                        onInputChange={handleInputChangePersenter}
                        loadOptions={loadPersenterSearch}
                        inputValue={queryPersenter}
                        placeholder={loading ? "Đang tải dữ liệu..." : "Tìm kiếm tên/mã"}
                        noOptionsMessage={() => queryPersenter ? "Không tìm thấy dữ liệu" : 'Tìm kiếm tên/mã'}
                        loadingMessage={() => 'Đang tìm kiếm...'}
                        cacheOptions
                        style={{ padding: 0 }}
                        defaultOptions={presenter}
                        onChange={(value: any) => {
                          setData({
                            ...data,
                            user_aff_phone: value?.phone,
                            user_aff_id: value?.value
                          })
                        }}
                        value={presenter?.filter((item: any) => item?.id == data?.user_aff_id || item?.id == data?.user_aff_id?.id)}
                        isDisabled={onlyView}
                        components={{
                          Option: customOptionPersenter
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {type == "view" && (
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup className="nutri-form">
                        <Label>Người tạo</Label>
                        <ValueText>{data?.created_uid?.name}</ValueText>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup className="nutri-form">
                        <Label>Ngày tạo</Label>
                        <ValueText>
                          {moment(data?.created_time).format(
                            "HH:mm:ss DD/MM/YYYY"
                          )}
                        </ValueText>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col md={6} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Ghi chú</Label>
                  {type != "view" ? (
                    <Input
                      type="text"
                      value={data?.note}
                      onChange={(e: any) => handleChangeInput(e)}
                      name="note"
                      placeholder={
                        type == "view" && !data?.note ? "---" : "Nhập ghi chú"
                      }
                    />
                  ) : (
                    <ValueText>{data?.note || "---"}</ValueText>
                  )}
                </FormGroup>
              </Col>
            </Row>
            {
              filterPhone?.length > 0 && userAffPhones?.length > 0 && onlyView !== true &&
              <p style={{ color: "red" }}>* Tìm thấy {filterPhone?.length} khách hàng trùng số điện thoại {filterPhone[0]?.phone} có mã giới thiệu là : {userAffPhonesString || "---"}
                <span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleActionModal({ type: "detailPhone", data: filterPhone })}> Xem chi tiết</span>
              </p>
            }
          </PageBody>
          <PageBody>
            <div className="nutri-title mb-3">
              Thông tin người thân/ Người bảo hộ
            </div>
            <Row>
              <Col md={from == "exam" || from == "reception" || from == 'servicepackage' || from == 'addcustomerservice' ? 6 : 8} xs={12}>
                <FormGroup className="nutri-form">
                  <Label>Lựa chọn</Label>
                  <div className="d-flex align-items-center">
                    <Row style={{ width: "100%" }}>
                      <Col xl={6}>
                        <div
                          className={
                            isInfo ? "nutri-radio active" : "nutri-radio"
                          }
                          onClick={() =>
                            type == "view" ? {} : setIsInfo(true)
                          }
                        >
                          <div className="icon"></div>
                          <div className="label">Có thông tin</div>
                        </div>
                      </Col>
                      <Col xl={6}>
                        <div
                          className={
                            !isInfo ? "nutri-radio active" : "nutri-radio"
                          }
                          onClick={() =>
                            type == "view" ? {} : setIsInfo(false)
                          }
                        >
                          <div className="icon"></div>
                          <div className="label">Không có thông tin</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            {isInfo &&
              rela?.map((item: any, index: number) => (
                <RelativeComponent
                  relaIndex={index}
                  data={item}
                  onChangeData={(dataRela: any) =>
                    handleUpdateRela(dataRela, index)
                  }
                  type={type}
                  onlyView={onlyView}
                  handleRemoveData={() => handleRemoveRela(index)}
                  handleAddData={() => handleAddRela()}
                  rela={rela}
                  onDeleteData={(id: number) => deleteRelation(id)}
                />
              ))}
          </PageBody>
          <PageBody>
            <div className="nutri-title mb-3">
              Danh sách sổ địa chỉ (Địa chỉ nhận hàng)
            </div>
            <div className="customer-address-container">
              {type === "view" && address?.length === 0 && (
                <p style={{ textAlign: "center", marginTop: 10 }}>
                  {"Chưa có địa chỉ nhận hàng nào"}
                </p>
              )}
              {address?.map((item: any, index: number) => {
                return (
                  <div key={`address-${index}`} className="customer-address">
                    <div className="add-head">
                      <h3>{item?.name}</h3>
                      {type !== "view" && (
                        <div className="add-action table-action">
                          <div
                            className="button-nutri"
                            onClick={() =>
                              props?.handleActionModal({
                                data: item,
                                index: index,
                                type: "editAddress",
                              })
                            }
                          >
                            <img
                              width={20}
                              height={20}
                              src={IconEdit}
                              alt="edit"
                            />
                          </div>
                          {item?.status !== 1 && (
                            <div
                              className="button-nutri"
                              onClick={() => {
                                let newAddress: any = cloneDeep(address);
                                newAddress.splice(index, 1);
                                setAddress([...newAddress]);
                              }}
                            >
                              <i className="uil-trash-alt"></i>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <span className="add-info">
                      {item?.street ? `${item?.street}, ` : ""}
                      {item?.wards_code?.name
                        ? `${item?.wards_code?.name}, `
                        : ""}

                      {item?.district_code?.name
                        ? `${item?.district_code?.name}, `
                        : ""}

                      {item?.provinces_code?.name
                        ? `${item?.provinces_code?.name}`
                        : ""}
                    </span>
                    <span className="add-phone">{item?.phone}</span>
                    <span className="add-default">
                      <span>
                        {item?.status === 1 ? "Địa chỉ mặc định" : ""}
                      </span>
                      <div
                        onClickCapture={() => {
                          item?.status !== 1 && handleSetAddressDefault(index);
                        }}
                        className={
                          item?.status === 1
                            ? "nutri-radio active"
                            : "nutri-radio"
                        }
                        onClick={() =>
                          type == "view"
                            ? {}
                            : setData({ ...data, type: "normal" })
                        }
                      >
                        <div className="icon"></div>
                      </div>
                    </span>
                  </div>
                );
              })}
              {type !== "view" && (
                <div
                  className="add-address"
                  onClick={() => {
                    props?.handleActionModal({ data: {}, type: "addAddress" });
                  }}
                >
                  <img src={img_bg_upload} />
                </div>
              )}
            </div>
          </PageBody>
          {type === "view" && (
            <CustomerTab
              {...props}
              {...data}
              handleChangeInput={handleChangeInput}
            />
          )}
        </Col>
        {type === "view" && (
          <Col md={6}>
            <CustomerHistory
              {...props}
              {...data}
              handleChangeInput={handleChangeInput}
            />
          </Col>
        )}
      </Row>
      {
        // !from &&
        <div className="bottom-action">
          {type == 'view' ? (
            <Button
              color="success"
              className="success-bland ml-2"
              onClick={() => {
                router?.push(`/customer/list`);
              }}
            >
              Đóng
            </Button>
          ) : (
            <Button
              color="success"
              className="success-bland ml-2"
              onClick={() => {
                if (checkS) {
                  props?.handleActionModal({ type: "close" })
                } else {
                  // props.closeModal();
                  router?.push(`/customer/list`);
                }
              }}
            >
              Đóng
            </Button>
          )}
          {!id && (
            <Button color="success" className="ml-2" onClick={handleSubmit}>
              Lưu
            </Button>
          )}
          {id && type == "view" && (
            <>
              {data?.status == 1 ?
                <Button
                  color="success"
                  className="danger-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ data: data, type: "stop" })
                  }
                >
                  Khóa
                </Button> : <Button
                  color="success"
                  className="danger-bland ml-2"
                  onClick={() =>
                    props?.handleActionModal({ data: data, type: "unstop" })
                  }
                >
                  Mở Khóa
                </Button>
              }
              <Button
                color="success"
                className="ml-2"
                onClick={() => router?.push(`/customer/${id}`)}
              >
                Chỉnh sửa
              </Button>
            </>
          )}
          {id && type != "view" && (
            <Button color="success" className="ml-2" onClick={handleEdit}>
              Lưu
            </Button>
          )}
        </div>
      }

      {loading && <Loader />}
    </PageContent>
  );
};

const Service = (props: any) => {
  const {
    columnOrder,
    data,
    filter,
    setFilter,
    id,
    type,
    onlyView,
    from,
    orderspackage_services,
    handleActionModal,
    loading,
    totalElements,
  } = props;

  return (
    <React.Fragment>
      <PageBody>
        <DataFilter
          filter={filter}
          configPage={configPage}
          setFilter={(filter: any) => setFilter(filter)}
          handleActionModal={(data: any) => handleActionModal(data)}
          columnOrder={columnOrder}
        />
        <DataTableList
          columnOrder={columnOrder}
          filter={filter}
          user={props?.user}
          data={data} loading={loading}
          page={filter?.page} limit={filter?.limit}
          orderspackage_services={orderspackage_services}
          configPage={configPage}
          history={props.history}
          loadings={loading}
          handleActionModal={(data: any) => handleActionModal(data)}
        />
        <Pagination
          link={`customer/orderpackage/${id}`}
          setPage={(page: number) => setFilter({ ...filter, page: page })}
          page={filter?.page}
          limit={filter?.limit}
          setLimit={(limit: number) => setFilter({ ...filter, limit: limit })}
          type={'noresetpage'}
          totalElements={totalElements}
        />
      </PageBody>
    </React.Fragment>
  )
}

const ChartPage = (props: any) => {
  const {
    data,
    type,
    onlyView,
    from,
  } = props;
  return (
    <PageContent
      style={
        from == "exam" || from == "reception"
          ? { width: "900px", maxHeight: "80vh", overflowX: "hidden" }
          : {}
      }
      className={onlyView ? "only-view" : ""}
    >
      <Row>
        {type === "view" && (
          <Col md={12}>
            <CustomerChart
              {...props}
              {...data}
            />
          </Col>
        )}
      </Row>
    </PageContent>
  );
};

const Monitor = (props: any) => {
  const {
    handleActionModal,
    rootUser,
    customer_id,
    dataMonitor,
    setDaDaMonitor,
    filter,
    setFilter,
    totalElements
  }
    = props;
  const router = useHistory()

  const [loading, setLoading] = useState(false);

  return (
    <React.Fragment>
      <PageBody>
        <DataFilterMonitor
          handleActionModal={(data: any) => handleActionModal(data)}
          customer_id={customer_id}
          filter={filter}
          setFilter={(filter: any) => setFilter(filter)}
        />
        <DataTableListMonitor
          monitor={dataMonitor}
          handleActionModal={(data: any) => handleActionModal(data)}
          loading={loading}
        />
        <Pagination
          setPage={(page: number) => setFilter({ ...filter, page: page })}
          page={filter?.page}
          limit={filter?.limit}
          setLimit={(limit: number) => setFilter({ ...filter, limit: limit })}
          type={'noresetpage'}
          totalElements={totalElements}
        />
      </PageBody>
      <div className="bottom-action">
        <Button color="success" className='success-bland ml-2' onClick={() => router?.push(`/customer/list`)}>Đóng</Button>
      </div>
    </React.Fragment>
  )
}

const DataTableList = (props: any) => {
  const { data, filter, loadings, limit, page, is_draft, configPage, handleActionModal, orderspackage_services, columnOrder } = props
    const router = useHistory()
    const start = limit * (page - 1)
  const RenderHeadData = () => {
    return (
      <thead>
        <tr>
          <th style={{ minWidth: 50, cursor: 'pointer' }}>STT</th>

          {
            (columnOrder?.map((itemCol: any, indexCol: number) => {
              if (itemCol?.status == 0) return null
              return (
                <th key={`header-${indexCol}`} style={{ minWidth: 120, cursor: 'pointer' }}>
                  <>{itemCol?.title}</>
                </th>
              )
            }))
          }
          <th style={{ minWidth: 100, cursor: 'pointer' }}>Thao tác</th>
        </tr>
      </thead>
    )
  }

  const gotoDetail = (item: any) => {
    router?.push(`/customer/oderhistory/${item?.id}/view`, { state: "fusionner" })
  }

  const checkPayment = (typePrice: any) => {
    switch (typePrice) {
      case "paid":
        return <span style={{ color: "#48A800" }}>Đã thanh toán</span>
      case "unpaid":
        return <span style={{ color: "#FF9D08" }}>Chưa thanh toán</span>
      case "partiallypaid":
        return <span style={{ color: "#3183FF" }}>Thanh toán 1 phần</span>
      default:
        return "---"
    }
  }

  const checkPaymentStatus = (status: any) => {
    return !(status == "paid" || status == null);
  }

  const checkStatus = (status: any, used: any, payment: any, type: any, time: any) => {
    const today = new Date();

    if (payment != "paid" || !(new Date(time) <= today)) {
      return <span style={{ color: "#3B5998" }}>Chưa hoạt động</span>
    }
    if (type == 'course' && payment == 'paid' || (new Date(time) <= today)) {
      return <span style={{ color: "#48A800" }}>Đang hoạt động</span>
    }
    if (type == 'course' && payment == 'unpaid') {
      return <span style={{ color: "#3B5998" }}>Chưa hoạt động</span>
    }

    if (used > 0) {
      if (status > 0) {
        return <span style={{ color: "#48A800" }}>Đang hoạt động</span>
      }
      else if (status < 0) {
        return <span style={{ color: "#FF0000" }}>Đã hết hạn</span>
      } else if (payment != "paid" || payment == null) {
        return <span style={{ color: "#3B5998" }}>Chưa hoạt động</span>
      }
    } else {
      return <span style={{ color: "#8229DB" }}>Đã kết thúc</span>
    }
  }
  const checkStatusAccount_card = (remaining: any, orderspackage_children: any, parent: any) => {
    let status = false;
    if (parent.payment_status !== "paid") {
      status = true;
    }
    for (let i = 0; i < orderspackage_children.length; i++) {
      if (orderspackage_children[i].payment_status !== "paid") {
        status = true;
        break;
      }
    }
    if (remaining > 0) {
      return <span style={{ color: "#48A800" }}>Đang hoạt động</span>
    }
    if (remaining == 0 && status == true) {
      return <span style={{ color: "#3B5998" }}>Chưa hoạt động</span>
    }
    if (remaining == 0 && status == false) {
      return <span style={{ color: "#8229DB" }}>Đã kết thúc</span>
    }
  }

  const checkPaymentCustomer = (payment: any) => {
    let i: any = 0
    payment.forEach((item: any) => {
      i += item?.payment_total
    })
    return i
  }

  const countUsers = (user: any) => {
    let i: any = 0
    user.forEach((item: any) => {
      if (item?.payment_status == "paid") {
        i += item?.customer_ids?.length
      }
    })
    return i
  }

  const principal = (totalAmount: any) => {
    let i: number = 0;
    totalAmount && totalAmount.forEach((item: any) => {
      if (item && item.sub_total) {
        const subTotalAsNumber = parseFloat(item.sub_total);
        if (!isNaN(subTotalAsNumber)) {
          i += subTotalAsNumber;
        }
      }
    });
    return i
  }

  const paid = (totalAmount: any) => {
    let i: any = 0
    totalAmount && totalAmount.forEach((item: any) => {
      item?.orderspackage_payment.forEach((pay: any) => {
        i += pay?.payment_total
      })
    })
    return i
  }

  const checkPayAccount_card = (orderspackage_children: any) => {
    let status = false;
    for (let i = 0; i < orderspackage_children.length; i++) {
      if (orderspackage_children[i].payment_status !== "paid") {
        status = true;
        break;
      }
    }
    return status
  }

  const countIdPayments = (item: any) => {
    let arr = [];
    if (item.payment_status !== "paid") {
      arr.push(item?.id);
    }
    item?.orderspackage_children?.map((i: any) => {
      if (i.payment_status !== "paid") {
        arr.push(i?.id);
      }
    }
    )
    return arr
  }

  const expiry = (payment: any[], orders: any): string => {
    const last = Array.isArray(payment) && payment.length > 0 ? payment[payment.length - 1] : undefined;
    const expiry_time = parseInt(orders?.expiry_number || '0', 10);
    if (last && new Date(last.created_time) > new Date(orders?.active_time_config)) {
      const newDate = new Date(last.created_time);
      if (orders?.expiry_type === "month") {
        newDate.setUTCDate(newDate.getUTCDate() + (expiry_time * 30) + 1);
      } else if (orders?.expiry_type === "year") {
        newDate.setUTCFullYear(newDate.getUTCFullYear() + expiry_time);
      } else {
        newDate.setUTCDate(newDate.getUTCDate() + expiry_time);
      }
      return newDate.toISOString();
    } else {
      const newDate = new Date(orders?.active_time_config);
      if (orders?.expiry_type === "month") {
        newDate.setUTCMonth(newDate.getUTCMonth() + expiry_time);
      } else if (orders?.expiry_type === "year") {
        newDate.setUTCFullYear(newDate.getUTCFullYear() + expiry_time);
      } else {
        newDate.setUTCDate(newDate.getUTCDate() + expiry_time);
      }
      return newDate.toISOString();
    }
  };
  const RenderColumn = (props: any) => {
    const { item, config } = props
    const timeDifference = moment(item?.expiry_time).diff(moment(), "days");
    const dateDifference = parseInt(item.count_examination) - parseInt(item?.used_examination);
    const remaining = parseInt(item.total_group) - parseInt(item?.total_group_used || 0);
    const used = parseInt(item?.total_group_used)
    switch (config?.value) {
      case 'order_code':
        return <td onClick={() => gotoDetail(item)}>{item?.code}</td>
        break;
      case 'order_name':
        return <td onClick={() => gotoDetail(item)}>{item?.name}</td>

        break;
      case 'expiry_time':
        return <td onClick={() => gotoDetail(item)}>
          {item?.type == 'account_card' ?
            'Không thời hạn' :
            item?.active_time_config == null ||
              item?.expiry_time == null ||
              item?.payment_status !== "paid"
              ?
              "---" : moment(expiry(item?.orderspackage_payment, item?.orderspackage_services[0])).format("DD/MM/YYYY")}
        </td>
        break;
      case 'discount_order':
        return <td onClick={() => gotoDetail(item)}>
          {
            item?.type === 'account_card' ? item?.payment_status === "paid" ?
              countUsers(item?.orderspackage_children) + item?.customer_ids?.length :
              countUsers(item?.orderspackage_children) :
              item?.customer_ids?.length
          }
        </td>
        break;
      case 'count_examination':
        return <td onClick={() => gotoDetail(item)}>{item?.count_examination ? item?.count_examination : PriceUtils.format(item?.total_group || 0)} {item?.type == "course" ? null : item?.type == 'account_card' ? '' : 'lần'}</td>

        break;
      case 'used_examination':
        return <td onClick={() => gotoDetail(item)}>{item?.type !== 'account_card' ? item?.used_examination : PriceUtils.format(parseInt(item?.total_group_used) || 0)} {item?.type == "course" ? " lần" : item?.type == 'account_card' ? '' : 'lần'}</td>

        break;
      case 'remaining':
        return <td style={{ color: "#48A800", fontWeight: "bold" }} onClick={() => gotoDetail(item)}>{dateDifference && !isNaN(dateDifference) ? dateDifference : remaining && !isNaN(remaining) ? PriceUtils.format(remaining || 0) : 0} {item?.type == "course" ? null : item?.type == 'account_card' ? '' : 'lần'}</td>

        break;
      case 'status':
        return <td onClick={() => gotoDetail(item)}>
          {
            item?.type == 'account_card' ?
              checkStatusAccount_card(remaining, item?.orderspackage_children, item) : checkStatus(timeDifference, dateDifference, item?.payment_status, item?.type, item?.active_time_config)
          }
        </td>
        break;
      case 'price':
        return <td style={{ fontWeight: "bold" }} onClick={() => gotoDetail(item)}>
          {item?.discount_type == 'percent'
            ? PriceUtils.format(item?.total - ((item?.total * item?.discount_value) || 0) + principal(item?.orderspackage_children))
            : PriceUtils.format(item?.total - (item?.discount_value || 0) + principal(item?.orderspackage_children))
          }
        </td>
        break;
      case 'price_paid':
        return <td style={{ fontWeight: "bold" }} onClick={() => gotoDetail(item)}>
          {
            item?.type == 'account_card' ? PriceUtils.format(paid(item?.orderspackage_children) + checkPaymentCustomer(item?.orderspackage_payment)) :
              PriceUtils.format((checkPaymentCustomer(item?.orderspackage_payment) || 0))
          }
        </td>
        break;
      case 'payment_status':
        return <td onClick={() => gotoDetail(item)}>
          {item?.type == 'account_card' && item?.orderspackage_children?.length > 0 ? '' : checkPayment(item?.payment_status)}
        </td>
        break;
    }
  }
  const RenderBobyData = () => {
    if (loadings) {
      return <RowLoading column={configPage.column} row={limit} />
    }
    if (!orderspackage_services || orderspackage_services.length === 0) {
      return <RowEmpty column={configPage.column} title="Chưa có gói thẻ dịch vụ nào!" />;
    }
    return (
      <tbody>
        {orderspackage_services && orderspackage_services.map((item: any, index: number) => {
          return (
            <>
              <tr key={`${item?.id}-${index}`}>
                <td onClick={() => gotoDetail(item)}>
                  {index + 1}
                </td>
                {
                  (
                    columnOrder?.map((itemCol: any, indexCol: number) => {
                      return itemCol?.status === 0 ? null : (
                        <RenderColumn key={`body-${index}-${indexCol}`} item={item} config={itemCol} onClick={() => gotoDetail(item)} />
                      );
                    })
                  )}
                <td>
                  <div className="table-action">
                    {
                      item?.type == 'account_card' && checkPayAccount_card(item?.orderspackage_children) ?
                        <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'addReceipts', orders_id: countIdPayments(item), })}>
                          <img
                            style={{ border: "none" }}
                            src={IconDolla}
                            width={20}
                            height={20}
                            alt=""
                          />
                        </div> :
                        checkPaymentStatus(item?.payment_status) && (
                          <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'addReceipts', orders_id: item?.id, })}>
                            <img
                              style={{ border: "none" }}
                              src={IconDolla}
                              width={20}
                              height={20}
                              alt=""
                            />
                          </div>
                        )}
                  </div>
                </td>
              </tr>
              {
                item?.orderspackage_children?.length > 0 &&
                <Item
                  item={item}
                  gotoDetail={gotoDetail}
                  checkPayment={checkPayment}
                  checkPaymentStatus={checkPaymentStatus}
                  handleActionModal={handleActionModal}
                  checkPaymentCustomer={checkPaymentCustomer}
                  columnOrder={columnOrder}
                />
              }
            </>
          )
        })}
      </tbody>
    )
  }
  return (
    <div>
      <Table className="mb-0 table-custom" responsive>
        <RenderHeadData />
        <RenderBobyData />
      </Table>
      {/* {loading && <Loader />} */}
    </div>
  );
};

const DataTableListMonitor = (props: any) => {
  const { monitor, loading, handleActionModal, getMonitor } = props

  const RenderHeadData = () => {
    return (
      <thead>
        <tr>
          <th className=" sticky-position" style={{ minWidth: 60, backgroundColor: "#ECECEC" }}>Thời gian</th>
          <th className=" sticky-position" style={{ minWidth: 50, backgroundColor: "#ECECEC" }}>Mục đích</th>
          <th className=" sticky-position" style={{ minWidth: 140, backgroundColor: "#ECECEC" }}>Mô tả diễn biến</th>
          <th className=" sticky-position" style={{ minWidth: 140, backgroundColor: "#ECECEC" }}>Hướng xử lý</th>
          <th className=" sticky-position" style={{ minWidth: 140, backgroundColor: "#ECECEC" }}>Theo dõi đánh giá</th>
          <th className=" sticky-position" style={{ width: 140, backgroundColor: "#ECECEC" }} >Thao tác</th>
        </tr>
      </thead>
    )
  }
  const RenderBobyData = () => {
    const router = useHistory()
    if (loading) {
      return <RowLoading column={configPage.column} row={monitor.length} />
    }
    if (!monitor || monitor.length === 0) {
      return <RowEmpty column={configPage.column} title="Chưa có gói thẻ dịch vụ nào!" />;
    }
    const MaxLines = ({ text, maxLines, data }: any) => {
      const [expanded, setExpanded] = useState(false);
      // Kiểm tra xem text có giá trị không phải là null hoặc undefined
      if (text === null || text === undefined) {
        return null; // hoặc có thể trả về một giá trị mặc định khác tùy thuộc vào yêu cầu của bạn
      }
      const lines = text.split('\n');
      const displayedLines = lines.slice(0, maxLines);
      return (
        <div>
          {displayedLines.map((line: any, index: any) => (
            <p key={index} dangerouslySetInnerHTML={{ __html: line }} />
          ))}
          {lines.length > maxLines && (
            <p style={{ textDecoration: "underline", color: "blue" }} onClick={() => handleActionModal({ type: 'detailMonitor', data: data })} >Xem thêm</p>
          )}
        </div>
      );
    };

    return (
      <tbody>
        {monitor && monitor.map((item: any, index: number) => {
          return (
            <>
              <tr key={index}>
                <td onClick={() => handleActionModal({ type: 'detailMonitor', data: item })} >
                  {moment(item?.day).format('DD/MM/YYYY')}</td>
                <td onClick={() => handleActionModal({ type: 'detailMonitor', data: item })}>
                  <MaxLines text={item?.purpose} maxLines={8} data={item} />
                </td>
                <td onClick={() => handleActionModal({ type: 'detailMonitor', data: item })}>
                  <MaxLines text={item?.describe_developments} maxLines={8} data={item} />
                </td>
                <td onClick={() => handleActionModal({ type: 'detailMonitor', data: item })} >
                  <MaxLines text={item?.solution} maxLines={8} data={item} />
                </td>
                <td onClick={() => handleActionModal({ type: 'detailMonitor', data: item })}>
                  <MaxLines text={item?.follow_reviews} maxLines={8} data={item} />
                </td>
                <td>
                  <div className="table-action">
                    <div className="button-nutri" onClick={() => handleActionModal({ type: 'editMonitor', data: item })}>
                      <img style={{ border: 'none' }} src={IconEdit} width={20} height={20} alt="" />
                    </div>
                    <div className="button-nutri" onClick={() => handleActionModal({ type: 'deleteMonitor', data: item })}><i className='uil-trash-alt'></i></div>
                  </div>
                </td>
              </tr>
            </>
          )
        })}
      </tbody>
    )
  }
  return (
    <div>
      <Table className="mb-0 table-custom" responsive>
        <RenderHeadData />
        <RenderBobyData />
      </Table>
      {loading && <Loader />}
    </div>
  );
}

const Item = (props: any) => {
  const { item, checkPayment, checkPaymentStatus, checkPaymentCustomer, columnOrder } = props;
  const router = useHistory()
  const checkStatus = (status: any) => {
    if (status == "paid") {
      return <span style={{ color: "#48A800" }}>Đang hoạt động</span>
    } else {
      return <span style={{ color: "#3B5998" }}>Chưa hoạt động</span>
    }
  }
  const gotoDetail = (item: any) => {
    router?.push(`/customer/oderhistory/${item?.id}/view`)
  }
  const RenderColumn = (props: any) => {
    const { children, config } = props
    switch (config?.value) {
      case 'order_code':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'order_name':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'expiry_time':
        return <td onClick={() => gotoDetail(children)}>
          {children?.orderspackage_services[0]?.type === 'account_card' ? 'Không thời hạn' : children?.orderspackage_services[0]?.expiry_time === null ? "---" : moment(children?.orderspackage_services[0]?.expiry_time).format('DD/MM/YYYY')}
        </td>
        break;
      case 'discount_order':
        return <td onClick={() => gotoDetail(children)}>{children?.payment_status === "paid" ? children?.customer_ids?.length : 0}</td>
        break;
      case 'count_examination':
        return <td onClick={() => gotoDetail(children)}>{PriceUtils.format(children?.total || 0)}</td>
        break;
      case 'used_examination':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'remaining':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'status':
        return <td onClick={() => gotoDetail(children)}>{checkStatus(children?.payment_status)}</td>
        break;
      case 'price':
        return <td onClick={() => gotoDetail(children)}>{PriceUtils.format(children?.sub_total || 0)}</td>
        break;
      case 'price_paid':
        return <td onClick={() => gotoDetail(children)}>{PriceUtils.format((checkPaymentCustomer(children?.orderspackage_payment) || 0))}</td>
        break;
      case 'payment_status':
        return <td onClick={() => gotoDetail(children)}>{checkPayment(children?.payment_status)}</td>
        break;
    }
  }
  const RenderColumn_2 = (props: any) => {
    const { children, config } = props
    switch (config?.value) {
      case 'order_code':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'order_name':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'expiry_time':
        return <td onClick={() => gotoDetail(item)}>{item?.type == 'account_card' ? 'Không thời hạn' : item?.expiry_time == null ? "---" : moment(item?.expiry_time).format('DD/MM/YYYY')}</td>

        break;
      case 'discount_order':
        return <td onClick={() => gotoDetail(item)}>{item?.payment_status === "paid" ? item?.customer_ids?.length : 0}</td>

        break;
      case 'count_examination':
        return <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.total || 0)}</td>
        break;
      case 'used_examination':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'remaining':
        return <td onClick={() => gotoDetail(children)}></td>
        break;
      case 'status':
        return <td onClick={() => gotoDetail(item)}>{checkStatus(item?.payment_status)}</td>

        break;
      case 'price':
        return <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.sub_total || 0)}</td>
        break;
      case 'price_paid':
        return <td onClick={() => gotoDetail(item)}>{PriceUtils.format((checkPaymentCustomer(item?.orderspackage_payment) || 0))}</td>

        break;
      case 'payment_status':
        return <td onClick={() => gotoDetail(item)}>{checkPayment(item?.payment_status)}</td>
        break;
    }
  }
  return (
    <>
      {item?.orderspackage_children && item?.orderspackage_children?.map((children: any, index: number) => (
        <tr key={index}>
          <td onClick={() => gotoDetail(item)}>
          </td>
          {
            (
              columnOrder?.map((itemCol: any, indexCol: number) => {
                return itemCol?.status === 0 ? null : (
                  <RenderColumn key={`body-${index}-${indexCol}`} children={children} config={itemCol} onClick={() => gotoDetail(children)} />
                );
              })
            )}
          <td>
            <div className="table-action">
              {checkPaymentStatus(children?.payment_status) && (
                <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'addReceipts', orders_id: children?.id, })}>
                  <img
                    style={{ border: "none" }}
                    src={IconDolla}
                    width={20}
                    height={20}
                    alt=""
                  />
                </div>
              )}
            </div>
          </td>
        </tr>
      ))}
      <tr>
        <td onClick={() => gotoDetail(item)}>
        </td>
        {
          (
            columnOrder?.map((itemCol: any, indexCol: number) => {
              return itemCol?.status === 0 ? null : (
                <RenderColumn_2 key={`body-${indexCol}`} children={item} config={itemCol} onClick={() => gotoDetail(item)} />
              );
            })
          )}
        <td>
          <div className="table-action">
            {checkPaymentStatus(item?.payment_status) && (
              <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'addReceipts', orders_id: item?.id, })}>
                <img
                  style={{ border: "none" }}
                  src={IconDolla}
                  width={20}
                  height={20}
                  alt=""
                />
              </div>
            )}
          </div>
        </td>
      </tr>
    </>
  );
}

const DataFilter = (props: any) => {
  const { setFilter, filter, handleActionModal, columnOrder } = props
  const [name, setName] = useState(filter?.name);
  const [fillterOpen, setFillterOpen] = useState(false);
  const timer = useRef<any>(null);

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      clearTimeout(timer.current)
      setFilter({
        ...filter,
        page: 1,
        name: e.target.value?.trim(),
      })
    }
  }

  const handleChange = (e: any) => {
    clearTimeout(timer.current)
    const { name, value } = e?.target
    setFilter({
      ...filter,
      page: 1,
      [name]: value
    })
  }

  const handleFilterMulti = (name: string, option: any, onChange: any) => {
    const value: any = [];
    option &&
      option.map((item: any) => {
        value.push(item.value);
      });
    onChange({ target: { name, value } });
  };

  const getFilterMulti = (list: any, value: any) => {
    if (value instanceof Array) {
      const option: any = [];
      list &&
        list.map((item: any) => {
          const found =
            value.length > 0 &&
            value.find((element: any) => element == item.value);
          if (found || found === 0) {
            option.push(item);
          }
        });
      return option;
    }
    return [];
  };
  return (
    <Row className="mb-3 filter-custom">
      <Col xl={12}>
        <Row>
          <Col xl={4}>
            <InputGroup>
              <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                <img src={IconSearch} width={18} height={18} alt="" />
              </InputGroupAddon>
              <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Mã hoặc tên gói thẻ dịch vụ" />
            </InputGroup>
          </Col>
          <Col xl={8}>
            <Row>
              <Col xl={4}>
                <Select
                  className="react-select mb-2"
                  classNamePrefix="react-select"
                  placeholder="-Trạng thái hoạt động-"
                  options={StatusList}
                  onChange={(value: any) => {
                    handleChange({ target: { name: 'use_status', value: value.value } })
                  }}
                // value={StatusList?.filter((option: any) => filter?.status === option.value)}
                ></Select>
              </Col>
              <Col xl={4}>
                <MultiSelect
                  className="react-select mb-2"
                  options={PaymentStatusList}
                  onChange={(val: any) => {
                    handleFilterMulti("payment_statuses", val, handleChange);
                  }}
                  value={getFilterMulti(PaymentStatusList, filter?.payment_statuses || [])}
                  labelledBy="-Trạng thái thanh toán-"
                  overrideStrings={{
                    allItemsAreSelected: "Đã chọn tất cả trạng thái",
                    clearSearch: "Xóa tìm kiếm",
                    clearSelected: "Xóa các lựa chọn",
                    noOptions: "Không tìm thấy kết quả nào",
                    search: "Tìm kiếm",
                    selectAll: "Chọn tất cả",
                    selectAllFiltered: "Select All (Filtered)",
                    selectSomeItems: "-Trạng thái thanh toán-",
                    create: "Create",
                  }}
                />
              </Col>
              <Col xl={4}>
                <div className="text-right" style={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <button type="button" className="ml-2 btn btn-light" onClick={() => {
                    handleActionModal({
                      type: 'filter',
                      data: columnOrder
                    })
                  }}>
                    <img style={{ border: 'none' }} src={IconSetting} width={20} height={20} alt="" />
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
const DataFilterMonitor = (props: any) => {
  const { setFilter, filter, handleActionModal } = props
  const handleChangeFilterDate = (date: any) => {
    if (date.length === 2) {
      const from = moment(date[0]).startOf("day").valueOf();
      const to = moment(date[1]).endOf("day").valueOf();
      setFilter({
        ...filter,
        from: from,
        to: to
      })
    } else if (date.length === 0) {
      setFilter({
        ...filter,
        from: undefined,
        to: undefined
      })
    }
  }

  return (
    <Row className="mb-3 filter-custom">
      <Col xl={12}>
        <Row>
          <Col xl={8}>
            <Row>
              <Col xl={4}>
                <InputGroup className="form-control picker-custom">
                  <Flatpickr
                    value={[
                      new Date(
                        moment(filter?.from)
                          .startOf("day")
                          .valueOf()
                      ),
                      new Date(
                        moment(filter?.to)
                          .startOf("day")
                          .valueOf()
                      ),
                    ]}
                    onChange={(date: any) => {
                      handleChangeFilterDate(date);
                    }}
                    options={{
                      mode: "range",
                      locale: Vietnamese,
                      dateFormat: "d/m/Y",
                    }}
                    className="flatpickr-input active"
                    placeholder="Ngày tạo"
                  />
                  <div className="icon-clear" style={{ right: 23 }} onClick={() => { setFilter({ ...filter, from: null, to: null }) }}>
                    <i className="uil-times mr-1"></i>
                  </div>
                  <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                    <img src={IconCalendarBlack} alt="icon" />
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            </Row>
          </Col>
          <Col xl={4}>
            <div style={{ marginLeft: "40px" }} className="text-right">
              <Button color="success" className="ml-" onClick={() => handleActionModal({ type: "addMonitor" })}>
                <i className='uil uil-plus mr-1'></i>
                Thêm mới
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
const RelativeComponent = (props: any) => {
  const {
    relaIndex,
    rela,
    onChangeData,
    data,
    type,
    onlyView,
    handleRemoveData,
    handleAddData,
    onDeleteData,
  } = props;
  const handleChangeData = (event?: any) => {
    let { value, name } = event.target;
    if (name == "name") {
      if (value?.length > 200) return;
    }
    if (name === "phone" || name === "guardian_phone" || name === "cccd") {
      value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "");
    }
    onChangeData({
      ...data,
      [name]: value,
    });
  };

  const handleClickRemove = () => {
    if (!!data?.id) {
      onDeleteData(data);
      handleRemoveData();
    } else {
      handleRemoveData();
    }
  };

  return (
    <Row key={relaIndex}>
      <Col md={3} xs={12}>
        <FormGroup className="nutri-form">
          <Label>Tên người thân</Label>
          <Input
            type="text"
            value={data?.name}
            onChange={(e: any) => handleChangeData(e)}
            name="name"
            placeholder={
              type == "view" && !data?.name ? "---" : "Nhập tên người thân"
            }
          />
        </FormGroup>
      </Col>
      <Col md={3} xs={12}>
        <FormGroup className="nutri-form">
          <Label>Quan hệ</Label>
          <Select
            placeholder={
              type == "view" && !data?.relationship ? "---" : "Chọn quan hệ"
            }
            className="react-select mb-2"
            classNamePrefix="react-select"
            menuPlacement="top"
            isDisabled={onlyView}
            onChange={(val: any) => {
              onChangeData({
                ...data,
                relationship: val?.value,
              });
            }}
            value={RelationList?.filter(
              (option: any) => data?.relationship == option.value
            )}
            options={RelationList}
          ></Select>
        </FormGroup>
      </Col>
      <Col md={3} xs={12}>
        <FormGroup className="nutri-form">
          <Label>Số điện thoại</Label>
          <InputGroup>
            <Input
              type="text"
              value={data?.phone}
              onChange={(e: any) => handleChangeData(e)}
              name="phone"
              placeholder={
                type == "view" && !data?.phone ? "---" : "Nhập số điện thoại"
              }
            />
            {type != "view" && (
              <InputGroupAddon
                addonType="append"
                className="d-flex align-items-center"
              >
                <img src={PhoneImageIcon} width={18} height={18} alt="" />
              </InputGroupAddon>
            )}
          </InputGroup>
        </FormGroup>
      </Col>
      <Col md={3} xs={12}>
        <FormGroup className="nutri-form">
          <Label>CMT/ CCCD</Label>
          <InputGroup>
            <Input
              type="text"
              value={data?.cccd}
              onChange={(e: any) => handleChangeData(e)}
              name="cccd"
              placeholder={type == "view" && !data?.cccd ? "---" : "Nhập số"}
            />
          </InputGroup>
        </FormGroup>
      </Col>
      {type != "view" && (
        <Col md={3} xs={12}>
          <FormGroup className="nutri-form">
            <Label></Label>
            {rela?.length == relaIndex + 1 ? (
              <Button
                onClick={handleAddData}
                className="nutri-square"
                color="success"
              >
                <i className="uil-plus"></i>
              </Button>
            ) : (
              <Button
                onClick={handleClickRemove}
                className="nutri-square bg-none"
                color="success"
              >
                <i className="uil-trash-alt"></i>
              </Button>
            )}
          </FormGroup>
        </Col>
      )}
    </Row>
  );
};

const RenderActionModal = (props: any) => {
  const [loading, setLoading] = useState(false);
  const { closeModal, action, loadData, modalIsOpen, setIsOpen, id, setMonitor, monitor, rootUser, getMonitor, handleActionModal, columnOrder, changeColumnOrder } = props;
  const router = useHistory();
  const [timeDay, setTimeDay] = useState<any>()
  const [name, setName] = useState('');
  const timer = useRef<any>(null);
  const checkFilter = () => {
    return columnOrder
  }
  const [itemList, setItemList] = useState<any>(checkFilter());

  useEffect(() => {
    setMonitor({
      ...monitor,
      day: moment().startOf("day").unix() * 1000,
    })
  }, [action?.type == "addMonitor"])

  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target;
    if (value === " ") return;
    if (value?.length > 2000) return;
    setMonitor({
      ...monitor,
      [name]: value,
    });
  };

  const handleDateChange = (selectedDates: any, dateStr: any, instance: any) => {
    handleChangeFilterDate(selectedDates);
    instance.close();
  };

  const handleChangeFilterDate = (date: Date | Date[]) => {
    const selectedDate = Array.isArray(date) ? date[0] : date;
    const from = moment(selectedDate).startOf("day").unix() * 1000;
    action?.type == "editMonitor" ?
      setTimeDay({
        ...timeDay,
        day: from,
      }) :
      setMonitor({
        ...monitor,
        day: from,
      })
  };

  const handleStop = async (status: any) => {
    setLoading(true);
    const params = {
      "status": status || 0,
    }
    const url = `${baseUrl}/customer/status/${action?.data?.id}`;
    let response: any = await APIClient.PUT(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Cập nhật trạng thái khách hàng thành công!");
      closeModal();
      router?.push("/customer/list");
      window.location.reload();
    }
  };

  // const handleStop = async () => {
  //   setLoading(true);
  //   const url = `${baseUrl}/branch/${action?.data?.id}`;
  //   const params = {
  //     status: 0,
  //   };
  //   let response: any = await APIClient.PUT(url, params);
  //   setLoading(false);
  //   if (response.error !== undefined) {
  //     toast.error(response.error.error_description);
  //   } else if (response.response !== undefined) {
  //     toast.success("Ngừng hoạt động khách hàng thành công");
  //     closeModal();
  //     loadData();
  //   }
  // };

  const handleDeleteAction = async () => {
    setLoading(true);
    const url = `${baseUrl}/customer-action/${action?.data?.id}`;
    let response: any = await APIClient.DELETE(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Xóa hoạt động thành công!");
      closeModal();
      props?.loadActionList();
    }
  };

  const handleUpdateActionStatus = async (status: any) => {
    const url = `${baseUrl}/customer-action/${action?.data?.id}`;
    const params = {
      ...action?.data,
      status,
    };
    let response: any = await APIClient.PUT(url, params);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Cập nhật hoạt động thành công");
      closeModal();
      props?.loadActionList();
    }
  };

  const handleAddMonitor = async () => {
    setLoading(true);
    const params = {
      day: monitor?.day,
      customer_id: monitor?.customer_id,
      purpose: monitor?.purpose,
      describe_developments: monitor?.describe_developments,
      solution: monitor?.solution,
      follow_reviews: monitor?.follow_reviews,
      created_uid: monitor?.created_uid,
    }
    const url = `${baseUrl}/customer-companion-tracking`;
    let response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Thêm theo dõi thành công");
      closeModal();
      setMonitor({
        day: moment().startOf("day").unix() * 1000,
        created_uid: rootUser.id,
        customer_id: monitor?.customer_id
      })
      getMonitor()
    }
  };

  const handleDeleteMonitor = async (id: any) => {
    setLoading(true);
    const url = `${baseUrl}/customer-companion-tracking/${id}`;
    let response: any = await APIClient.DELETE(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Xóa theo dõi thành công");
      closeModal();
      getMonitor()
    }
  };

  const handleUpdateMonitor = async (id: any) => {
    const url = `${baseUrl}/customer-companion-tracking/${id}`;
    const params = {
      day: timeDay?.day ? timeDay.day : action?.data?.day,
      customer_id: monitor?.customer_id ? monitor.customer_id : action?.data?.customer_id?.id,
      purpose: monitor?.purpose ? monitor.purpose : action?.data?.purpose,
      describe_developments: monitor?.describe_developments ? monitor?.describe_developments : action?.data?.describe_developments,
      solution: monitor?.solution ? monitor?.solution : action?.data?.solution,
      follow_reviews: monitor?.follow_reviews ? monitor?.follow_reviews : action?.data?.follow_reviews,
      created_uid: monitor?.created_uid ? monitor?.created_uid : action?.data?.created_uid,
    }
    let response: any = await APIClient.PUT(url, params);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Cập nhật theo dõi thành công");
      closeModal();
      setMonitor({
        day: moment().startOf("day").unix() * 1000,
        created_uid: rootUser.id,
        customer_id: monitor?.customer_id
      })
      getMonitor()
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      clearTimeout(timer.current)
      setName(e.target.value)
    }
  }

  const handleSettingColumn = async () => {
    setLoading(true)
    changeColumnOrder(itemList)
    closeModal()
    toast.success("Điều chỉnh cột hiển thị danh sách thành công")
    setLoading(false)
  }

  const handleCheckbox = (itemCol: any) => {
    if (itemCol?.disable) return
    const status = itemCol?.status == 1 ? 0 : 1
    const data = itemList?.reduce((prev: any, item: any) => {
      prev = [...prev, {
        ...item,
        status: itemCol?.value == item?.value ? status : item?.status
      }]
      return prev
    }, [])
    setItemList(data)
  }
  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    setItemList((prevItem: any) => (arrayMoveImmutable(prevItem, oldIndex, newIndex)));
  };
  const SortableItem = SortableElement((props: any) => {
    const { value } = props
    return (
      <li className='filter-item'>
        <div className='filter-name' onClick={() => {
          handleCheckbox(value)
        }}>
          <img style={{ border: 'none' }} src={value.disable === 1 ? IconCheckedDisiable : value?.status === 1 ? IconCheckedActive : IconChecked} width={20} height={20} alt="" />
          <span>{value?.title}</span>
        </div>
        <img style={{ border: 'none' }} src={IconSort} width={20} height={20} alt="" />
      </li>
    )
  })

  const SortableList = SortableContainer((props: any) => {
    const { items } = props;
    if (name?.length > 0) {
      return (
        <ul className='filter-container'>
          {items?.filter((column: any) => indexOf(column.title, name) > -1)?.map((value: any, index: number) => (
            <SortableItem key={`item-${index}`} index={index} value={value} distance={1} />
          ))}
        </ul>
      );
    }
    return (
      <ul className='filter-container'>
        {items?.map((value: any, index: number) => (
          <SortableItem key={`item-${index}`} index={index} value={value} distance={1} />
        ))}
      </ul>
    );
  })

  if (action?.type == 'receipts') {
    return (
      <ModalPopup
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
      >
        <ReceiptsAdd closeModal={() => closeModal()} action={action} loadData={() => loadData()} orders_id_service_package={action?.orders_id} />
      </ModalPopup>
    )
  }

  if (action?.type == 'addMonitor' || action?.type == 'detailMonitor' || action?.type == 'editMonitor') {
    return (
      <CardBody className="p-0" style={{ width: 900 }}>
        <div className="modal-header">
          <h5 className="modal-title" id="modal-action-title">
            {
              action?.type === 'addMonitor'
                ? "Thêm theo dõi đồng hành"
                : action?.type === 'detailMonitor'
                  ? "Chi tiết theo dõi đồng hành"
                  : "Chỉnh sửa theo dõi đồng hành"
            }
          </h5>
          <button onClick={() => closeModal()} type="button" className="close">
            {" "}
            <span aria-hidden="true">×</span>{" "}
          </button>
        </div>
        <div className="modal-body pt-2 pb-2" style={{ maxHeight: "600px", overflowY: "auto", marginTop: "20px" }}>
          <Col xl={12}>
            <FormGroup row className="label-only">
              <Col xl={6}>
                <Label>
                  <span style={{ color: "red" }}>*</span> Thời gian
                </Label>
                <InputGroup className='form-control picker-custom'>
                  {
                    action?.type == 'addMonitor' ?
                      <Flatpickr
                        value={monitor.day
                          ? [
                            new Date(
                              moment(Number(monitor.day)).startOf("day").unix() * 1000
                            ),
                          ]
                          : null
                        }
                        onChange={handleDateChange}
                        options={{
                          mode: "single",
                          locale: Vietnamese,
                          dateFormat: "d/m/Y",
                        }}
                        placeholder="-Thời gian tạo-"
                      /> :
                      <Flatpickr
                        value={
                          timeDay?.day ? [new Date(moment(timeDay?.day).startOf("day").unix() * 1000)]
                            : action?.data?.day
                              ? [new Date(moment(action?.data?.day).startOf("day").unix() * 1000)]
                              : null
                        }
                        onChange={handleDateChange}
                        options={{
                          mode: "single",
                          locale: Vietnamese,
                          dateFormat: "d/m/Y",
                          clickOpens: action.type !== "detailMonitor",// Tắt hành động mở lịch
                        }}
                        placeholder="-Thời gian tạo-"
                      />

                  }
                  <div className="icon-clear" style={{ right: 23 }} onClick={() => { setMonitor({ ...monitor, day: null }) }}>
                    <i className="uil-times mr-1"></i>
                  </div>
                  <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                    <img src={IconCalendarBlack} alt="icon" />
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xl={6}>
                <Label>
                  <span style={{ color: "red" }}>*</span> Người tạo
                </Label>
                <Input
                  type="text"
                  value={action?.type == 'addMonitor' ? rootUser?.name : action?.data?.created_uid?.name}
                  name="name"
                  disabled={true}
                  placeholder="Nhập tên khách hàng"
                />
              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                {
                  action?.type == 'detailMonitor' &&
                  <Label>Mục đích</Label>
                }
                {
                  action?.type !== 'detailMonitor' ?
                    <InputTitleTop
                      title="Mục đích" typeEdit="sunEditor"
                      value={action?.type == 'addMonitor' ? monitor?.purpose : action?.data?.purpose} onChange={(e: any) => handleChangeInput(e)}
                      type="textarea" name="purpose"
                      disabled={action?.type === 'detailMonitor'}
                      rows={2}
                    />
                    : action?.data?.purpose ? (
                      <p
                        style={{
                          borderRadius: "5px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #DCDCDC",
                          padding: "6px",
                        }}
                        dangerouslySetInnerHTML={{ __html: action?.data?.purpose }}
                      >
                      </p>
                    ) : (
                      <p>---</p>
                    )
                }

              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                {
                  action?.type == 'detailMonitor' &&
                  <Label>Mô tả diễn biến</Label>
                }
                {
                  action?.type !== 'detailMonitor' ?
                    <InputTitleTop
                      title="Mô tả diễn biến" typeEdit="sunEditor"
                      value={action?.type == 'addMonitor' ? monitor?.describe_developments : action?.data?.describe_developments} onChange={(e: any) => handleChangeInput(e)}
                      type="textarea" name="describe_developments"
                      disabled={action?.type === 'detailMonitor'}
                      rows={2}
                    />
                    : action?.data?.describe_developments ? (
                      <p
                        style={{
                          borderRadius: "5px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #DCDCDC",
                          padding: "6px",
                        }}
                        dangerouslySetInnerHTML={{ __html: action?.data?.describe_developments }}
                      >
                      </p>
                    ) : (
                      <p>---</p>
                    )
                }
              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                {
                  action?.type == 'detailMonitor' &&
                  <Label>Hướng xử lý</Label>
                }
                {
                  action?.type !== 'detailMonitor' ?
                    <InputTitleTop
                      title="Hướng xử lý" typeEdit="sunEditor"
                      value={action?.type == 'addMonitor' ? monitor?.solution : action?.data?.solution} onChange={(e: any) => handleChangeInput(e)}
                      type="textarea" name="solution"
                      disabled={action?.type === 'detailMonitor'}
                      rows={2}
                    />
                    : action?.data?.solution ? (
                      <p
                        style={{
                          borderRadius: "5px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #DCDCDC",
                          padding: "6px",
                        }}
                        dangerouslySetInnerHTML={{ __html: action?.data?.solution }}
                      >
                      </p>
                    ) : (
                      <p>---</p>
                    )
                }
              </Col>
              <Col xl={12} style={{ marginTop: "20px" }}>
                {
                  action?.type == 'detailMonitor' &&
                  <Label>Theo dõi đánh giá</Label>
                }
                {
                  action?.type !== 'detailMonitor' ?
                    <InputTitleTop
                      title="Theo dõi đánh giá" typeEdit="sunEditor"
                      value={action?.type == 'addMonitor' ? monitor?.follow_reviews : action?.data?.follow_reviews} onChange={(e: any) => handleChangeInput(e)}
                      type="textarea" name="follow_reviews"
                      disabled={action?.type === 'detailMonitor'}
                      rows={2}
                    />
                    : action?.data?.follow_reviews ? (
                      <p
                        style={{
                          borderRadius: "5px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #DCDCDC",
                          padding: "6px",
                        }}
                        dangerouslySetInnerHTML={{ __html: action?.data?.follow_reviews }}
                      >
                      </p>
                    ) : (
                      <p>---</p>
                    )
                }
              </Col>
            </FormGroup>
          </Col>
        </div>
        {
          <div className="modal-footer">
            <Button
              onClick={closeModal}
              className="ml-2 success-bland"
              color="success"
              type="button"
            >
              Đóng
            </Button>
            {
              action?.type == "editMonitor" &&
              <Button
                color="success"
                className="danger-bland ml-2"
                onClick={() => handleActionModal({ type: 'deleteMonitor', data: action?.data })}
              >
                Xóa
              </Button>
            }
            {
              action?.type !== 'detailMonitor' &&
              <Button
                onClick={() => {
                  if (action?.type == "addMonitor") {
                    handleAddMonitor()
                  } else if (action?.type == "editMonitor") {
                    handleUpdateMonitor(action?.data?.id)
                  }
                }}
                className="ml-2"
                color="success"
                type="button"
              >
                Lưu
              </Button>
            }

          </div>
        }
        {loading && <Loader />}
      </CardBody>
    )
  }

  if(action?.type == 'deleteMonitor') {
    return (
      <CardBody className="p-0" style={{ width: 600}}>
        <div className="modal-header">
          <h5 className="modal-title" id="modal-action-title">
            Thông báo
          </h5>
          <button onClick={() => closeModal()} type="button" className="close">
            {" "}
            <span aria-hidden="true">×</span>{" "}
          </button>
        </div>
        <div className="modal-body pt-2 pb-2">
          <Col md={12}>
            <FormGroup row className="label-only">
            <p
              className="font-size-14"
              style={{ textAlign: "center", width: "100%" }}
            >
              {`Bạn có chắc chắn muốn xóa theo dõi này?`}
            </p>
            </FormGroup>
          </Col>
        </div>
        <div className="modal-footer">
          <Button
            onClick={closeModal}
            className="ml-2 success-bland"
            color="success"
            type="button"
          >
            {" "}
            Hủy bỏ
          </Button>
          <Button
            onClick={() => {
              handleDeleteMonitor(action?.data?.id);
            }}
            className="ml-2"
            color="success"
            type="button"
          >
            {" "}
            Xác nhận{" "}
          </Button>
        </div>
      </CardBody>
    )
  }

  return (
    <CardBody className="p-0" style={{ width: action?.type === 'filter' ? 600 : 450 }}>
      <div className="modal-header">
        <h5 className="modal-title" id="modal-action-title">
          {
            action?.type === "activeAction"
              ? "Xác nhận thành công?"
              : action?.type === 'filter'
                ? 'Điều chỉnh cột hiển thị danh sách'
                : action?.type === "rejectAction"
                  ? "Xác nhận thất bại?"
                  : action?.type === "detailPhone"
                    ? "Khách hàng trùng"
                    : action?.type === "stopAction"
                      ? "Xóa hoạt động?"
                      : "Thông báo"
          }
        </h5>
        <button onClick={() => closeModal()} type="button" className="close">
          {" "}
          <span aria-hidden="true">×</span>{" "}
        </button>
      </div>
      {
        action?.data && action?.type === "detailPhone" && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {action.data.map((item: any, index: any) => (
              <div
                style={{
                  marginLeft: "15px",
                  marginTop: "15px",
                  display: "flex",
                  alignItems: "center"
                }}
                key={index}
              >
                <span style={{ marginRight: "5px", width: "20px", textAlign: "right" }}>{`${index + 1}.`}</span>
                <span>{`${item.name} - `}</span>
                <a target="_blank" style={{ color: "blue" }} href={`/customer/${item?.id}/view`}>{`${item.code}`}</a>
              </div>
            ))}
          </div>
        )
      }

      <div className="modal-body pt-2 pb-2">
        <Col md={12}>
          <FormGroup row className="label-only">
            {action?.type === "stop" ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >
                Bạn có chắc chắn muốn khóa khách hàng <br />{" "}
                <b className="text-danger">{action?.data?.name}</b>
              </p>
            ) : action?.type === "deleteAction" ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >{`Bạn có chắc chắn xoá hoạt động này?`}</p>
            ) : action?.type === "unstop" ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >
                Bạn có chắc chắn muốn mở khóa khách hàng <br />{" "}
                <b className="text-danger">{action?.data?.name}</b>
              </p>
            ) : action?.type === "activeAction" ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >{`Bạn có chắc chắn xác nhận thành công hoạt động này?`}</p>
            ) : action?.type === "rejectAction" ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >{`Bạn có chắc chắn xác nhận thất bại hoạt động này?`}</p>
            ) : action?.type === "close" && !id ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >{`Bạn có chắc chắn hủy bỏ thêm mới khách hàng này?`}</p>
            ) : action?.type === "close" && id ? (
              <p
                className="font-size-14"
                style={{ textAlign: "center", width: "100%" }}
              >{`Bạn có chắc chắn hủy bỏ chỉnh sửa khách hàng này?`}</p>
            )
              : action?.type === "deleteMonitor" ? (
                <p
                  className="font-size-14"
                  style={{ textAlign: "center", width: "100%" }}
                >{`Bạn có chắc chắn muốn xóa theo dõi này?`}</p>
              ) : (
                ""
              )}
            {action?.type === 'filter' &&
              <Col className='p-2' md={12}>
                <p className='text-center'>Tích chọn cột để hiển thị. Kéo thả để thay đổi nhanh vị trí các cột hiển thị</p>
                <InputGroup>
                  <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                    <img src={IconSearch} width={18} height={18} alt="" />
                  </InputGroupAddon>
                  <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tìm dữ liệu" />
                </InputGroup>
                <div className='filter-sort-bor'></div>
                <div className='filter-sort'>
                  <SortableList distance={1} items={itemList} onSortEnd={onSortEnd} />
                </div>
              </Col>
            }
          </FormGroup>
        </Col>
      </div>
      <div className="modal-footer">
        {action?.type === 'filter' &&
          <>
            <Button
              onClick={closeModal}
              className="ml-2 success-bland" color="success" type="button"
            > Đóng </Button>
            <Button
              onClick={() => {
                setItemList(COLUMN_ORDER)
              }}
              className="ml-2 success-bland" color="success" type="button"
            > Quay về mặc định</Button>
            <Button
              onClick={() => {
                handleSettingColumn()
              }}
              className="ml-2" color="success" type="button"
            > Lưu </Button>
          </>
        }
      </div>
      {
        action?.type !== "detailPhone" && action?.type !== "filter" &&
        <div className="modal-footer">
          <Button
            onClick={closeModal}
            className="ml-2 success-bland"
            color="success"
            type="button"
          >
            {" "}
            Hủy bỏ
          </Button>
          <Button
            onClick={() => {
              action?.type === "deleteAction" && handleDeleteAction();
              action?.type === "activeAction" && handleUpdateActionStatus(1);
              action?.type === "rejectAction" && handleUpdateActionStatus(-1);
              action?.type === "deleteMonitor" && handleDeleteMonitor(action?.data?.id);
              action?.type === "stop" && handleStop(0);
              action?.type === "unstop" && handleStop(1)
              if (action?.type === "close") {
                closeModal();
                if (id) {
                  router?.push(`/customer/${id}/view`);
                } else {
                  router?.push(`/customer/list`);
                }
              }
            }}
            className="ml-2"
            color="success"
            type="button"
          >
            {" "}
            Xác nhận{" "}
          </Button>
        </div>
      }
      {loading && <Loader />}
    </CardBody>
  );
};

const ValueText = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
`;

const mapState = (state: any) => {
  return {
    user: state.Auth.user,
    columnOrder: state.Layout.columnOrder,
  };
};

const PageContent = styled.div`
  &.only-view {
    .nutri-form {
      input {
        border: none;
        pointer-events: none;
      }
      .react-select__indicators {
        display: none !important;
      }
      .react-select__control {
        border: none;
        background-color: transparent !important;
      }
    }
  }
`;

export default connect(mapState, { changeColumnOrder })(List);
